var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEina03Bold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20190801 at Fri Mar 25 12:36:24 2016\n By www-data\nCopyright (c) 2013 Textaxis. v 1.0 by In~igo Jerez. Barcelona. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Eina03Bold",
    horizAdvX: 582
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Eina03Bold",
    fontWeight: 400,
    fontStretch: "normal",
    unitsPerEm: 1000,
    panose1: "2 0 0 0 0 0 0 0 0 0",
    ascent: 777,
    descent: -223,
    xHeight: 524,
    capHeight: 710,
    bbox: "-57 -266 1265 1097",
    underlineThickness: 50,
    underlinePosition: -100,
    unicodeRange: "U+0020-FB02"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fi",
    unicode: "fi",
    horizAdvX: 611,
    d: "M233 524h81v-112h-81v-412h-142v412h-75v112h75v42q0 92 47.5 138t130.5 46l42 -2v-122q-6 1 -22 1q-56 0 -56 -58v-45zM460 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24zM389 0v524h142v-524h-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fl",
    unicode: "fl",
    horizAdvX: 597,
    d: "M233 524h81v-112h-81v-412h-142v412h-75v112h75v42q0 92 47.5 138t130.5 46l42 -2v-122q-6 1 -22 1q-56 0 -56 -58v-45zM532 0h-142v750h142v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null",
    horizAdvX: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 260
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 282,
    d: "M82 218l-25 492h168l-25 -492h-118zM141 -8q-39 0 -64.5 25t-25.5 64t25.5 64.5t64.5 25.5q40 0 65 -25.5t25 -64.5q0 -40 -25 -64.5t-65 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 444,
    d: "M189 710v-326h-134v326h134zM389 710v-326h-134v326h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 616,
    d: "M586 514l-22 -104h-90l-23 -110h90l-22 -104h-90l-41 -196h-107l41 196h-87l-41 -196h-107l41 196h-98l22 104h98l23 110h-98l22 104h98l42 196h107l-42 -196h87l42 196h107l-42 -196h90zM280 410l-23 -110h87l23 110h-87z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    d: "M337 -125h-72v111q-112 6 -172 73t-60 165h144q1 -40 23.5 -68.5t64.5 -36.5v178l-53 15q-79 22 -119.5 75.5t-40.5 128.5q0 84 60 141t153 66v112h72v-112q99 -12 155 -76t56 -159h-144q-2 77 -67 99v-162l28 -7q183 -50 183 -221q0 -83 -57 -139.5t-154 -69.5v-113z M197 521q0 -10 1 -18t5.5 -15t7 -11t10.5 -9t11.5 -7t16 -8t16.5 -8v146q-30 -5 -49 -24t-19 -46zM400 197q0 56 -63 80v-156q63 17 63 76z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 963,
    d: "M234 0l392 710h103l-392 -710h-103zM186 489q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM76 489q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5zM665 220 q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM555 220q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 675,
    d: "M105 540q0 76 55 130.5t153 54.5t153 -54.5t55 -130.5q0 -120 -147 -186l113 -124q20 46 20 103l-4 57h129q3 -28 3 -55q0 -116 -59 -203l121 -132h-172l-38 42q-85 -57 -196 -57q-113 0 -185.5 57t-72.5 151q0 141 136 201q-64 70 -64 146zM295 109q60 0 107 26 l-150 166q-44 -20 -63 -42.5t-19 -55.5q0 -41 33 -67.5t92 -26.5zM236 540q0 -35 46 -85l8 -9l29 13q71 30 71 81q0 30 -21.5 51t-55.5 21q-35 0 -56 -20.5t-21 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 244,
    d: "M189 710v-326h-134v326h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 365,
    d: "M235 292q0 -246 108 -458h-143q-110 180 -110 458t110 458h143q-108 -212 -108 -458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 365,
    d: "M130 292q0 246 -108 458h143q110 -180 110 -458t-110 -458h-143q108 212 108 458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 388,
    d: "M377 559l-110 -36l67 -93l-73 -54l-68 94l-68 -94l-73 53l69 94l-110 36l28 86l110 -36v116h90v-116l110 36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    d: "M224 524h134v-195h195v-134h-195v-195h-134v195h-195v134h195v195z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 260,
    d: "M66 161h157l-87 -303h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 411,
    d: "M367 329v-134h-323v134h323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 260,
    d: "M130 -8q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 476,
    d: "M22 0l289 710h143l-289 -710h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    d: "M291 -15q-126 0 -192 101.5t-66 268.5t66 268.5t192 101.5t192 -101.5t66 -268.5t-66 -268.5t-192 -101.5zM291 587q-56 0 -83 -56t-27 -176t27 -176t83 -56t83 56t27 176t-27 176t-83 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    d: "M533 120v-120h-448v120h151v446h-148v95l176 49h118v-590h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    d: "M540 0h-489v120l278 270q53 50 53 113q0 39 -27 63.5t-69 24.5q-47 0 -71.5 -27.5t-24.5 -70.5l3 -39h-144q-3 17 -3 41q0 103 66.5 166.5t173.5 63.5q110 0 176 -61t66 -158q0 -70 -26 -121t-91 -109l-161 -142h290v-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    d: "M224 303v121h66q51 0 77 22.5t26 60.5t-24.5 62.5t-71.5 24.5q-50 0 -75 -29.5t-25 -70.5h-142q0 98 67.5 164.5t174.5 66.5q109 0 173 -57.5t64 -151.5q0 -107 -96 -149q104 -40 104 -158q0 -95 -70.5 -159.5t-180.5 -64.5q-109 0 -178 63t-73 168h142q2 -45 30 -72.5 t79 -27.5q48 0 77 26t29 67q0 43 -26.5 68.5t-82.5 25.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M550 272v-127h-68v-145h-134v145h-332v108l313 457h153v-438h68zM348 520h-1l-170 -248h171v248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    d: "M60 295l59 415h387v-134h-277l-20 -140q16 16 47.5 28.5t65.5 12.5q60 0 105.5 -21.5t70.5 -58t36.5 -77.5t11.5 -85q0 -109 -70.5 -179.5t-184.5 -70.5q-106 0 -172.5 58.5t-74.5 155.5h147q7 -34 32.5 -57.5t67.5 -23.5q50 0 79.5 32t29.5 85t-29.5 85t-79.5 32 q-32 0 -56.5 -14t-33.5 -28l-9 -15h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    d: "M297 -15q-116 0 -186.5 75t-70.5 185q0 105 60 218.5t177 246.5h176q-144 -154 -208 -263q35 19 83 19q103 0 163.5 -67.5t60.5 -167.5q0 -104 -71.5 -175t-183.5 -71zM404 231q0 52 -30 85t-77 33t-77 -33t-30 -85t30 -85t77 -33t77 33t30 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    d: "M547 710v-130q-170 -220 -218 -580h-151q51 339 205 578h-204v-88h-144v220h512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M291 -15q-114 0 -180 57t-66 151q0 52 24 99.5t70 74.5q-77 51 -77 153q0 90 62 147.5t167 57.5t168 -58.5t63 -148.5q0 -101 -79 -151q46 -28 70 -75t24 -99q0 -94 -66 -151t-180 -57zM291 296q-46 0 -73 -26t-27 -66q0 -38 26 -65t74 -27t74 27t26 65q0 40 -27 66 t-73 26zM291 427q44 0 69.5 24t25.5 63q0 34 -25 60t-70 26t-69 -25t-24 -59q0 -40 25 -64.5t68 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    d: "M285 725q116 0 186.5 -75t70.5 -185q0 -105 -60 -218.5t-177 -246.5h-176q144 157 208 262q-35 -18 -83 -18q-103 0 -163.5 67.5t-60.5 167.5q0 104 71.5 175t183.5 71zM178 479q0 -52 30 -85t77 -33t77 33t30 85t-30 85t-77 33t-77 -33t-30 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 260,
    d: "M130 -8q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5zM130 341q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 263,
    d: "M130 341q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5zM66 161h157l-87 -303h-127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    d: "M528 151v-140l-474 184v112l474 184v-140l-297 -100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    d: "M553 222v-134h-524v134h524zM553 436v-134h-524v134h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    d: "M54 11v140l297 100l-297 100v140l474 -184v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 532,
    d: "M33 513q0 92 64 152t169 60q110 0 171.5 -59t61.5 -151q0 -45 -18 -83.5t-44 -63.5t-52 -46.5t-44 -44t-18 -45.5l2 -20h-140q-2 13 -2 22q0 44 17.5 80t43 59.5t51 44.5t43 44.5t17.5 48.5q0 39 -24 61.5t-64 22.5t-65.5 -24.5t-25.5 -63.5l6 -53h-142q-7 26 -7 59z M260 -8q-40 0 -65 24.5t-25 64.5q0 39 25 64.5t65 25.5q39 0 64.5 -25.5t25.5 -64.5t-25.5 -64t-64.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 818,
    d: "M481 278q0 70 -62 70q-41 0 -65.5 -33t-24.5 -86q0 -36 18.5 -54.5t48.5 -18.5q40 0 62.5 36t22.5 86zM616 45h117q-52 -77 -137 -121t-182 -44q-172 0 -273 102.5t-101 266.5q0 163 109 271.5t271 108.5q159 0 258.5 -87.5t99.5 -227.5q0 -117 -63.5 -181.5 t-143.5 -64.5q-66 0 -93 45q-37 -45 -102 -45q-69 0 -110.5 43t-41.5 117q0 88 47 150.5t127 62.5q75 0 109 -48l8 34h92l-45 -223q-2 -8 -2 -13q0 -15 8.5 -25.5t23.5 -10.5q39 0 66 43t27 111q0 113 -74.5 172t-193.5 59q-123 0 -199 -80.5t-76 -208.5q0 -132 75.5 -207 t203.5 -75q54 0 107.5 21.5t87.5 54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 684,
    d: "M151 0h-153l267 710h154l267 -710h-157l-43 122h-292zM341 530h-2l-98 -277h198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 665,
    d: "M388 0h-313v710h300q117 0 176.5 -54.5t59.5 -140.5q0 -55 -26.5 -95.5t-72.5 -61.5q50 -19 79.5 -60t29.5 -97q0 -94 -60 -147.5t-173 -53.5zM384 293h-167v-162h167q90 0 90 81q0 37 -22.5 59t-67.5 22zM374 579h-157v-154h157q43 0 66.5 19.5t23.5 57.5 q0 34 -22.5 55.5t-67.5 21.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 778,
    d: "M42 356q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168t149.5 -62q72 0 122 36.5t66 102.5h156q-20 -128 -114.5 -203t-229.5 -75q-155 0 -256 102t-101 267z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 746,
    d: "M330 0h-255v710h255q177 0 275.5 -98t98.5 -257t-98.5 -257t-275.5 -98zM550 355q0 104 -55.5 162.5t-168.5 58.5h-105v-442h105q113 0 168.5 58.5t55.5 162.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 575,
    d: "M221 0h-146v710h471v-134h-325v-149h310v-134h-310v-293z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 800,
    d: "M452 262v131h305q1 -15 1 -37q0 -164 -101 -265.5t-252 -101.5q-160 0 -261.5 101t-101.5 266q0 164 103.5 266.5t259.5 102.5q130 0 224.5 -73.5t119.5 -192.5h-157q-16 59 -67 93t-120 34q-97 0 -153 -62t-56 -168q0 -105 56.5 -168.5t152.5 -63.5q73 0 125.5 37 t71.5 101h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 739,
    d: "M664 710v-710h-146v293h-297v-293h-146v710h146v-283h297v283h146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 580,
    d: "M369 229v481h146v-477q0 -112 -67 -179t-180 -67q-111 0 -178.5 61t-67.5 169l3 48h146q-3 -18 -3 -48q0 -48 27 -74.5t73 -26.5q49 0 75 30.5t26 82.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 693,
    d: "M711 0h-180l-202 305l-108 -118v-187h-146v710h146v-338l289 338h190l-270 -295z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 547,
    d: "M536 134v-134h-461v710h146v-576h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 834,
    d: "M209 710l208 -275l208 275h134v-710h-140v484l-200 -257h-4l-200 257v-484h-140v710h134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 749,
    d: "M217 469v-469h-142v710h147l310 -469v469h142v-710h-147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 643,
    d: "M221 403h158q48 0 72 23t24 63t-24 63.5t-72 23.5h-158v-173zM221 269v-269h-146v710h304q122 0 182 -61t60 -160q0 -98 -61.5 -159t-180.5 -61h-158z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 822,
    d: "M780 355q0 -168 -113 -273l148 -206h-166l-96 134q-67 -25 -142 -25q-161 0 -265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 674,
    d: "M663 0h-169l-133 269h-140v-269h-146v710h322q113 0 175 -61t62 -161q0 -72 -32.5 -125t-93.5 -78zM488 488q0 40 -23.5 64t-67.5 24h-176v-173h176q45 0 68 22.5t23 62.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 635,
    d: "M317 116q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5 t21 -98q0 -96 -77.5 -156.5t-203.5 -60.5q-71 0 -125 20.5t-85 55.5t-46.5 76t-17.5 87h144q3 -47 38 -78t100 -31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 546,
    d: "M541 710v-137h-195v-573h-146v573h-195v137h536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 748,
    d: "M374 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 696,
    d: "M532 710h160l-269 -710h-150l-269 710h164l181 -516h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1050,
    d: "M524 502l-144 -502h-154l-218 710h164l132 -502h2l142 502h158l142 -502h2l132 502h160l-218 -710h-154l-144 502h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 694,
    d: "M347 478l165 232h178l-258 -349l272 -361h-183l-173 245l-175 -245h-183l272 361l-261 349h181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 638,
    d: "M485 710h169l-262 -462v-248h-146v248l-262 462h169l165 -313h2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 668,
    d: "M620 710v-128l-386 -448h390v-134h-580v128l386 448h-382v134h572z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 337,
    d: "M315 -35v-131h-245v916h245v-131h-112v-654h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 476,
    d: "M165 710l289 -710h-143l-289 710h143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 337,
    d: "M22 -166v131h112v654h-112v131h245v-916h-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    d: "M531 255h-140l-100 271l-100 -271h-140l184 454h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 500,
    d: "M500 -85v-134h-500v134h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    horizAdvX: 359,
    d: "M75 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 635,
    d: "M207 468q22 29 62.5 48.5t92.5 19.5q111 0 176 -78t65 -196t-65 -196t-176 -78q-114 0 -166 76v-64h-131v750h142v-282zM203 262q0 -65 35.5 -107t93.5 -42t93.5 42t35.5 107t-35.5 107t-93.5 42t-93.5 -42t-35.5 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 569,
    d: "M32 262q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -78 -73.5 -141t-176.5 -63q-114 0 -188.5 78.5t-74.5 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 635,
    d: "M428 468v282h142v-750h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q52 0 92.5 -19.5t62.5 -48.5zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 326,
    d: "M227 524h81v-112h-81v-412h-142v412h-75v112h75v42q0 92 47.5 138t130.5 46l42 -2v-122q-6 1 -22 1q-56 0 -56 -58v-45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 626,
    d: "M435 460v64h131v-504q0 -105 -68 -172t-185 -67q-111 0 -172.5 59t-68.5 132h142q14 -69 101 -69q53 0 81 27t28 75v73q-51 -68 -153 -68q-107 0 -173 75.5t-66 187.5t66 187.5t173 75.5q112 0 164 -76zM428 273q0 62 -35 100t-92 38t-92 -38t-35 -100t35 -100t92 -38 t92 38t35 100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 605,
    d: "M207 750v-274q45 60 145 60q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -84.5v-299h-142v750h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 272,
    d: "M136 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24zM65 0v524h142v-524h-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 272,
    d: "M136 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24zM65 -208v732h142v-732h-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 570,
    d: "M398 524h178l-196 -223l210 -301h-168l-136 207l-79 -90v-117h-142v750h142v-464z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 272,
    d: "M207 0h-142v750h142v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 923,
    d: "M535 298v-298h-142v311q0 103 -84 103q-49 0 -75.5 -30t-26.5 -83v-301h-142v524h131v-64q41 76 151 76q104 0 152 -74q67 74 174 74q92 0 141 -57t49 -152v-327h-142v311q0 103 -84 103q-50 0 -76 -30.5t-26 -85.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 605,
    d: "M196 524v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 635,
    d: "M207 56v-264h-142v732h131v-64q52 76 166 76q111 0 176 -78t65 -196t-65 -196t-176 -78q-52 0 -92.5 19.5t-62.5 48.5zM203 262q0 -65 35.5 -107t93.5 -42t93.5 42t35.5 107t-35.5 107t-93.5 42t-93.5 -42t-35.5 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 635,
    d: "M428 56q-22 -29 -62.5 -48.5t-92.5 -19.5q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64h131v-732h-142v264zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 373,
    d: "M361 528v-133q-15 3 -28 3q-63 0 -94.5 -33t-31.5 -104v-261h-142v524h131v-68q45 73 148 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 501,
    d: "M251 -12q-214 0 -227 182h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5 t72.5 -48t30 -96q0 -73 -59.5 -120.5t-162.5 -47.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 312,
    d: "M225 412v-412h-142v412h-71v112h71v130h142v-130h77v-112h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 552,
    d: "M277 171l128 353h147l-210 -524h-132l-210 524h150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 859,
    d: "M537 0l-106 324h-2l-107 -324h-133l-183 524h147l105 -345l108 345h128l109 -347l106 347h144l-183 -524h-133z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 540,
    d: "M545 524l-195 -258l201 -266h-171l-110 159l-110 -159h-171l201 266l-195 258h171l104 -150l104 150h171z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 552,
    d: "M119 -208l88 217l-207 515h151l126 -350l127 350h148l-293 -732h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 545,
    d: "M491 407l-263 -284h267v-123h-445v117l262 284h-258v123h437v-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 356,
    d: "M291 -166q-96 0 -140 47t-44 141v154q0 55 -51 55h-16v122h16q51 0 51 55v154q0 94 44 141t140 47l43 -2v-131q-17 2 -34 2q-34 0 -47 -15t-13 -49v-149q0 -78 -50 -114q50 -38 50 -114v-149q0 -34 13 -49t47 -15l34 2v-131q-18 -2 -43 -2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 296,
    d: "M219 0h-142v750h142v-750z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 356,
    d: "M65 -166l-43 2v131q17 -2 34 -2q34 0 47 15t13 49v149q0 76 49 114q-49 36 -49 114v149q0 34 -13 49t-47 15l-34 -2v131q18 2 43 2q96 0 140 -47t44 -141v-154q0 -55 51 -55h16v-122h-16q-51 0 -51 -55v-154q0 -94 -44 -141t-140 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    d: "M389 169q-47 0 -106.5 23t-90.5 23q-28 0 -46 -12t-22 -24l-5 -12l-101 61q2 5 5.5 13t17.5 28t32 35.5t50 28t70 12.5q52 0 109 -23t88 -23q28 0 46 12t22 24l5 12l101 -61q-2 -5 -5.5 -13t-17.5 -28t-32 -35.5t-50 -28t-70 -12.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 282,
    d: "M82 310h118l25 -492h-168zM141 536q39 0 64.5 -25t25.5 -64t-25.5 -64.5t-64.5 -25.5q-40 0 -65 25.5t-25 64.5q0 40 25 64.5t65 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    d: "M255 -12v104q-96 14 -156.5 87t-60.5 176t60.5 176.5t156.5 86.5v104h72v-103q92 -11 145.5 -71t62.5 -130h-146q-13 50 -62 66v-259q50 17 62 67h146q-5 -44 -27.5 -85.5t-70 -75t-110.5 -40.5v-103h-72zM180 355q0 -105 75 -130v259q-36 -12 -55.5 -46t-19.5 -83z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    d: "M502 159l79 -90q-69 -84 -185 -84q-46 0 -115 22.5t-107 22.5q-26 0 -49.5 -12.5t-34.5 -25.5l-11 -12l-81 86q4 6 11.5 16t36 31.5t62.5 33.5q45 25 45 77q0 22 -9 44h-95v95h52q-31 71 -31 143q0 97 66 158t176 61q107 0 173.5 -62t66.5 -164l-3 -41h-144q3 13 3 39 q0 43 -24.5 70.5t-71.5 27.5q-43 0 -70.5 -26t-27.5 -69q0 -16 2 -30.5t7 -30.5t8 -24t11.5 -27.5t10.5 -24.5h155v-95h-129q0 -4 0.5 -11t0.5 -11q0 -57 -26 -93q20 -5 50.5 -15t57 -16.5t53.5 -6.5q53 0 87 44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 600,
    d: "M108 252q0 46 20 86l-75 76l95 95l78 -79q34 15 75 15q37 0 73 -14l78 78l95 -95l-74 -74q21 -44 21 -88q0 -40 -15 -75l68 -67l-95 -95l-65 64q-40 -20 -86 -20q-49 0 -88 21l-65 -65l-95 95l69 69q-14 36 -14 73zM213 252q0 -36 26 -62t62 -26t61.5 26t25.5 62 t-25.5 61.5t-61.5 25.5t-62 -25.5t-26 -61.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    d: "M12 710h154l124 -248h2l124 248h154l-177 -331h99v-100h-128v-60h128v-100h-128v-119h-146v119h-130v100h130v60h-130v100h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 288,
    d: "M77 749h134v-325h-134v325zM77 325h134v-325h-134v325z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 562,
    d: "M28 287q0 42 18.5 75.5t36 46.5t35.5 22q-38 46 -38 119t57.5 124t158.5 51q59 0 102 -17t65.5 -45.5t33 -56.5t12.5 -58h-137q-3 24 -23 42.5t-61 18.5q-33 0 -51.5 -16.5t-18.5 -39.5q0 -42 44 -61l115 -51q80 -35 119.5 -80t39.5 -112q0 -42 -18.5 -76t-36 -47 t-35.5 -22q38 -46 38 -118q0 -73 -57.5 -124t-158.5 -51q-59 0 -102 17t-65.5 45.5t-33 56.5t-12.5 58h137q3 -24 23 -42.5t61 -18.5q33 0 51.5 16.5t18.5 39.5q0 42 -44 61l-115 51q-80 35 -119.5 80t-39.5 112zM330 314l-120 52q-51 -19 -51 -66q0 -26 17 -42.5t59 -35.5 l118 -53q52 19 52 67q0 27 -17 43.5t-58 34.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    horizAdvX: 440,
    d: "M129 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM311 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 774,
    d: "M23 356q0 157 105 263t264 106t264 -106t105 -263t-105 -263t-264 -106t-264 106t-105 263zM131 356q0 -119 72 -195t189 -76t189 76t72 195t-72 195t-189 76t-189 -76t-72 -195zM206 356q0 84 53 140t134 56q80 0 126 -45t52 -101h-106q-5 24 -25 39t-47 15 q-41 0 -62.5 -28t-21.5 -76t21.5 -76t62.5 -28q27 0 47 14.5t25 39.5h106q-6 -56 -52 -101t-126 -45q-81 0 -134 56t-53 140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 412,
    d: "M163 321q-65 0 -97.5 31.5t-32.5 82.5q0 103 159 124l69 9v5q0 20 -14.5 31.5t-39.5 11.5q-49 0 -58 -45h-110q4 54 45.5 96t124.5 42q81 0 120.5 -38t39.5 -105v-165q0 -16 2.5 -34t4.5 -27l3 -10h-102q-6 17 -9 32q-36 -41 -105 -41zM140 438q0 -33 47 -33 q33 0 53.5 21.5t20.5 55.5v9l-44 -7q-77 -13 -77 -46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 588,
    d: "M44 262l108 216h140l-110 -216l110 -216h-140zM296 262l108 216h140l-110 -216l110 -216h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    d: "M29 329h524v-294h-134v160h-390v134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 564,
    d: "M287 197q-114 0 -189 75.5t-75 188.5t75 188.5t189 75.5t189 -75.5t75 -188.5t-75 -188.5t-189 -75.5zM287 276q79 0 128.5 52t49.5 133q0 80 -49.5 132.5t-128.5 52.5t-129 -52.5t-50 -132.5q0 -81 49.5 -133t129.5 -52zM403 331h-83l-33 71h-26v-71h-74v259h100 q55 0 84 -25t29 -69q0 -54 -43 -79zM294 521h-33v-50h33q30 0 30 25t-30 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    horizAdvX: 417,
    d: "M395 720v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 384,
    d: "M22 555q0 71 49 120.5t121 49.5t121 -49.5t49 -120.5t-49 -120.5t-121 -49.5t-121 49.5t-49 120.5zM122 555q0 -31 19 -51.5t51 -20.5t51 20.5t19 51.5t-19 51.5t-51 20.5t-51 -20.5t-19 -51.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    d: "M224 524h134v-110h195v-134h-195v-110h-134v110h-195v134h195v110zM553 134v-134h-524v134h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twosuperior",
    unicode: "\xB2",
    horizAdvX: 392,
    d: "M350 436h-308v84l167 142q34 29 34 67q0 20 -12 34t-36 14q-23 0 -36 -13t-13 -37l2 -24h-108q-1 11 -1 25q0 66 45 108.5t111 42.5q69 0 113.5 -41.5t44.5 -101.5q0 -48 -17.5 -80.5t-59.5 -64.5l-69 -53h143v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threesuperior",
    unicode: "\xB3",
    horizAdvX: 389,
    d: "M144 605v90h44q25 0 38.5 12t13.5 33q0 16 -12.5 27.5t-32.5 11.5q-24 0 -37 -14t-13 -37h-106q0 63 42 107t114 44t111 -35t39 -93q0 -68 -54 -96q59 -26 59 -97q0 -57 -46 -94.5t-113 -37.5q-68 0 -108.5 38.5t-42.5 102.5h105q3 -41 46 -41q19 0 30.5 10.5t11.5 26.5 q0 42 -50 42h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    horizAdvX: 359,
    d: "M136 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "mu",
    unicode: "\xB5",
    horizAdvX: 596,
    d: "M298 -12q-69 0 -106 22v-198h-132v712h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 690,
    d: "M268 -198v456q-116 0 -175.5 63t-59.5 163q0 98 63 162t172 64h345v-908h-136v771h-73v-771h-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 260,
    d: "M130 167q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    horizAdvX: 251,
    d: "M19 -216l37 61q22 -21 57 -21q41 0 41 34q0 33 -40 33q-8 0 -15.5 -2.5t-10.5 -4.5l-4 -3l-44 25l29 108h66l-16 -60q4 2 22 2q41 0 67 -26.5t26 -68.5q0 -51 -32 -80t-81 -29q-32 0 -57.5 8t-35.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onesuperior",
    unicode: "\xB9",
    horizAdvX: 292,
    d: "M220 869v-433h-109v325h-83v78l100 30h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 430,
    d: "M215 321q-84 0 -138.5 56.5t-54.5 137.5t54.5 137.5t138.5 56.5t138.5 -57t54.5 -137t-54.5 -137t-138.5 -57zM215 608q-36 0 -59 -26t-23 -67q0 -40 23.5 -66.5t58.5 -26.5q34 0 57.5 26.5t23.5 66.5q0 41 -23.5 67t-57.5 26z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 588,
    d: "M436 478l108 -216l-108 -216h-140l110 216l-110 216h140zM184 478l108 -216l-108 -216h-140l110 216l-110 216h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 815,
    d: "M116 272v325h-83v78l100 30h92v-433h-109zM145 0l392 710h103l-392 -710h-103zM426 85v89l189 260h108v-258h39v-91h-39v-85h-98v85h-199zM530 176h95v131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 860,
    d: "M116 272v325h-83v78l100 30h92v-433h-109zM145 0l392 710h103l-392 -710h-103zM496 0v84l167 142q34 28 34 67q0 20 -12 34t-36 14q-23 0 -36 -13t-13 -37l2 -24h-108q-1 11 -1 25q0 66 45 108.5t111 42.5q69 0 113.5 -41.5t44.5 -101.5q0 -48 -17 -79.5t-60 -65.5 l-69 -53h143v-102h-308z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 886,
    d: "M54 403h105q3 -41 46 -41q19 0 30.5 10.5t11.5 26.5q0 42 -50 42h-39v90h44q52 0 52 44q0 16 -12.5 27.5t-32.5 11.5q-24 0 -37 -14t-13 -37h-106q0 63 42 107t114 44t111 -35t39 -93q0 -67 -54 -95q59 -26 59 -97q0 -57 -46 -94.5t-113 -37.5q-68 0 -108.5 38.5 t-42.5 102.5zM216 0l392 710h103l-392 -710h-103zM497 85v89l189 260h108v-258h39v-91h-39v-85h-98v85h-199zM601 176h95v131z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 532,
    d: "M499 16q0 -92 -64 -152t-169 -60q-110 0 -171.5 59t-61.5 151q0 45 18 83.5t44 63.5t52 46.5t44 44t18 45.5l-2 20h140q2 -13 2 -22q0 -44 -17.5 -80t-43 -59.5t-51 -44.5t-43 -44.5t-17.5 -48.5q0 -39 24 -61.5t64 -22.5t65.5 24.5t25.5 63.5l-6 53h142q7 -26 7 -59z M272 537q40 0 65 -24.5t25 -64.5q0 -39 -25 -64.5t-65 -25.5q-39 0 -64.5 25.5t-25.5 64.5t25.5 64t64.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM201 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM344 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM186 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM407 766q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM253 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM435 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54 q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM298 860q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14t-13 -36zM221 860q0 53 35 88.5t90 35.5t90 -35.5t35 -88.5t-35 -88.5t-90 -35.5t-90 35.5t-35 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 988,
    d: "M141 0h-163l372 710h588v-134h-365v-149h350v-134h-350v-159h365v-134h-511v122h-225zM425 563l-157 -310h159v310h-2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 778,
    d: "M315 -216l37 61q22 -21 57 -21q41 0 41 34q0 33 -40 33q-8 0 -15.5 -2.5t-10.5 -4.5l-4 -3l-44 25l22 83q-139 14 -227.5 114t-88.5 253q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168 t149.5 -62q72 0 122 36.5t66 102.5h156q-19 -122 -106 -195.5t-213 -81.5l-9 -34q4 2 22 2q41 0 67 -26.5t26 -68.5q0 -51 -32 -80t-81 -29q-32 0 -57.5 8t-35.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM195 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM324 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM173 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM241 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM423 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53 t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM5 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM145 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM-13 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM56 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM238 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 746,
    d: "M330 0h-255v288h-70v134h70v288h255q177 0 275.5 -98t98.5 -257t-98.5 -257t-275.5 -98zM550 355q0 103 -55.5 160.5t-168.5 57.5h-105v-151h173v-134h-173v-151h105q113 0 168.5 57.5t55.5 160.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 749,
    d: "M217 469v-469h-142v710h147l310 -469v469h142v-710h-147zM446 766q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM281 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM402 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM252 863l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM478 766q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5 t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM321 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54 q0 -32 -21.5 -53t-53.5 -21zM503 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    d: "M44 414l95 95l152 -152l152 152l95 -95l-152 -152l152 -152l-95 -95l-152 152l-152 -152l-95 95l152 152z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105q-124 0 -216 64l-78 -87l-61 56l76 86q-90 103 -90 251q0 160 104 265t265 105q121 0 215 -64l78 87l62 -57l-77 -86q91 -102 91 -250zM626 355q0 77 -37 137l-298 -335q49 -33 120 -33q95 0 155 63.5t60 167.5zM196 355 q0 -81 37 -138l297 335q-51 34 -119 34q-95 0 -155 -63.5t-60 -167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM236 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM363 942h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM209 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM282 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM464 760q-33 0 -54 21t-21 53 q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 638,
    d: "M485 710h169l-262 -462v-248h-146v248l-262 462h169l165 -313h2zM310 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    horizAdvX: 643,
    d: "M221 182v-182h-146v710h146v-86h158q122 0 182 -61t60 -160q0 -98 -61.5 -159.5t-180.5 -61.5h-158zM221 319h158q96 0 96 84t-96 84h-158v-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 619,
    d: "M591 157q0 -75 -53 -121.5t-133 -46.5q-91 0 -137.5 48t-47.5 115h130q0 -19 15 -32t39 -13q21 0 35 12t14 35q0 18 -11.5 30.5t-37.5 28.5l-15 9q-79 48 -79 119q0 44 36 103l6 10q2 3 6 10t5.5 9.5t4.5 8t3.5 8.5t2 7.5t2 9t0.5 9.5q0 30 -20 51.5t-56 21.5 q-93 0 -93 -112v-477h-142v456q0 126 61 194.5t176 68.5q94 0 153.5 -55.5t59.5 -138.5q0 -12 -1 -22.5t-4 -21t-5 -17t-7.5 -17.5t-8 -15t-10.5 -17t-10 -17l-6 -10q-12 -20 -12 -32q0 -18 19 -30l15 -9q51 -30 78.5 -67.5t27.5 -92.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM170 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM280 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM151 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM369 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5 t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM217 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21 t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM399 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM252 695q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14 t-13 -36zM175 695q0 53 35 88.5t90 35.5t90 -35.5t35 -88.5t-35 -88.5t-90 -35.5t-90 35.5t-35 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 931,
    d: "M232 -12q-95 0 -144.5 45t-49.5 115q0 69 49.5 110.5t153.5 57.5l136 21v5q0 38 -25 57.5t-69 19.5q-84 0 -93 -64h-140q7 77 64 129t172 52q123 0 182 -62q72 62 172 62q115 0 187.5 -77.5t72.5 -195.5l-2 -42h-380q7 -54 40 -82.5t87 -28.5q75 0 101 57h143 q-23 -80 -90.5 -129.5t-157.5 -49.5q-128 0 -203 91q-62 -91 -206 -91zM254 98q60 0 91.5 31.5t31.5 85.5v21l-122 -21q-80 -14 -80 -62q0 -55 79 -55zM639 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 569,
    d: "M212 -212l34 55q22 -21 57 -21q17 0 29 9.5t12 26.5q0 15 -10 25.5t-30 10.5q-8 0 -15.5 -2.5t-10.5 -5.5l-4 -2l-41 25l20 82q-98 14 -159.5 89.5t-61.5 181.5q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5 t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -73 -67.5 -134t-159.5 -69l-9 -38q4 2 22 2q40 0 64 -26t24 -66q0 -47 -30.5 -76t-77.5 -29q-32 0 -56.5 8t-33.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM155 760h147l61 -171 h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM284 760h147l-80 -171 h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM136 672l161 83l161 -83 v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM203 603q-33 0 -54 21 t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM385 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 272,
    d: "M-4 760h147l61 -171h-128zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 272,
    d: "M134 760h147l-80 -171h-128zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 272,
    d: "M207 524v-524h-142v524h142zM-25 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 272,
    d: "M46 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM228 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 610,
    d: "M204 550l-39 58l92 46q-41 26 -94 54l89 69q60 -31 113 -70l109 55l39 -58l-91 -46q156 -153 156 -379q0 -126 -76.5 -208.5t-196.5 -82.5q-119 0 -196 80t-77 194q0 117 68.5 195.5t182.5 78.5q32 0 60.5 -7t40.5 -13l12 -7q-27 50 -79 97zM174 262q0 -65 37 -107 t94 -42t94 42t37 107t-37 107t-94 42t-94 -42t-37 -107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 605,
    d: "M196 524v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131zM371 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5 t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM159 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM296 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM146 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM370 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5 t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM216 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21 t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM398 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    d: "M291 -8q-38 0 -62 24t-24 61t24.5 61.5t61.5 24.5t61.5 -24.5t24.5 -61.5t-24 -61t-62 -24zM291 361q-38 0 -62 24t-24 61q0 38 24.5 62t61.5 24t61.5 -24t24.5 -62q0 -37 -24 -61t-62 -24zM553 329v-134h-524v134h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 614,
    d: "M307 -12q-91 0 -159 46l-55 -63l-50 45l55 62q-66 75 -66 184q0 115 76 194.5t199 79.5q87 0 154 -43l54 61l50 -45l-52 -60q69 -77 69 -187q0 -115 -76 -194.5t-199 -79.5zM440 262q0 47 -19 82l-186 -211q32 -20 72 -20q58 0 95.5 40t37.5 109zM174 262q0 -44 16 -78 l184 209q-28 18 -67 18q-58 0 -95.5 -40t-37.5 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM160 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM291 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM135 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM207 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM389 603q-33 0 -54 21t-21 53q0 33 21 54t54 21 q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 552,
    d: "M119 -208l88 217l-207 515h151l126 -350l127 350h148l-293 -732h-140zM276 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 630,
    d: "M207 43v-251h-142v958h142v-270q53 56 148 56q113 0 178 -77t65 -197q0 -118 -65 -196t-178 -78q-87 0 -148 55zM207 268q0 -67 31.5 -110.5t91.5 -43.5q58 0 92 42.5t34 105.5t-34 105.5t-92 42.5q-56 0 -89.5 -40.5t-33.5 -101.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 552,
    d: "M119 -208l88 217l-207 515h151l126 -350l127 350h148l-293 -732h-140zM187 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM369 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53 t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Amacron",
    unicode: "\u0100",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM529 878v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "amacron",
    unicode: "\u0101",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM494 720v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Abreve",
    unicode: "\u0102",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM343 530h-2l-98 -277h198zM344 839q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "abreve",
    unicode: "\u0103",
    horizAdvX: 635,
    d: "M439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM301 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43 t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aogonek",
    unicode: "\u0104",
    horizAdvX: 688,
    d: "M635 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 69 43 116l-35 99h-292l-43 -122h-153l267 710h154l267 -710h-63q-50 -36 -50 -86q0 -16 9 -26t26 -10q14 0 25 7zM343 530h-2l-98 -277h198z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aogonek",
    unicode: "\u0105",
    horizAdvX: 635,
    d: "M551 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 69 43 116v41q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q114 0 166 -76v64h131v-524h-29q-50 -36 -50 -86q0 -16 9 -26t26 -10q14 0 25 7zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42 t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cacute",
    unicode: "\u0106",
    horizAdvX: 778,
    d: "M42 356q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168t149.5 -62q72 0 122 36.5t66 102.5h156q-20 -128 -114.5 -203t-229.5 -75q-155 0 -256 102t-101 267zM386 941h147l-80 -171h-128z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cacute",
    unicode: "\u0107",
    horizAdvX: 569,
    d: "M32 262q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -78 -73.5 -141t-176.5 -63q-114 0 -188.5 78.5t-74.5 195.5zM280 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccircumflex",
    unicode: "\u0108",
    horizAdvX: 778,
    d: "M42 356q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168t149.5 -62q72 0 122 36.5t66 102.5h156q-20 -128 -114.5 -203t-229.5 -75q-155 0 -256 102t-101 267zM228 858l161 83l161 -83v-112 l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccircumflex",
    unicode: "\u0109",
    horizAdvX: 569,
    d: "M32 262q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -78 -73.5 -141t-176.5 -63q-114 0 -188.5 78.5t-74.5 195.5zM136 672l161 83l161 -83v-112l-161 79 l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Cdotaccent",
    unicode: "\u010A",
    horizAdvX: 778,
    d: "M42 356q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168t149.5 -62q72 0 122 36.5t66 102.5h156q-20 -128 -114.5 -203t-229.5 -75q-155 0 -256 102t-101 267zM399 760q-38 0 -62 24t-24 61 t24.5 61.5t61.5 24.5t61.5 -24.5t24.5 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cdotaccent",
    unicode: "\u010B",
    horizAdvX: 569,
    d: "M32 262q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -78 -73.5 -141t-176.5 -63q-114 0 -188.5 78.5t-74.5 195.5zM296 592q-38 0 -62 24t-24 61t24 61.5 t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccaron",
    unicode: "\u010C",
    horizAdvX: 778,
    d: "M42 356q0 165 101 267t256 102q135 0 229.5 -75t114.5 -203h-156q-16 66 -66 102.5t-122 36.5q-96 0 -149.5 -62t-53.5 -168t53.5 -168t149.5 -62q72 0 122 36.5t66 102.5h156q-20 -128 -114.5 -203t-229.5 -75q-155 0 -256 102t-101 267zM398 750l-161 83v112l161 -79 l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccaron",
    unicode: "\u010D",
    horizAdvX: 569,
    d: "M32 262q0 117 74.5 195.5t188.5 78.5q112 0 176.5 -63t73.5 -141h-146q-8 34 -37 56t-68 22q-56 0 -88 -40.5t-32 -107.5t32 -107.5t88 -40.5q39 0 68 22t37 56h146q-9 -78 -73.5 -141t-176.5 -63q-114 0 -188.5 78.5t-74.5 195.5zM294 560l-161 83v112l161 -79l161 79 v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcaron",
    unicode: "\u010E",
    horizAdvX: 746,
    d: "M330 0h-255v710h255q177 0 275.5 -98t98.5 -257t-98.5 -257t-275.5 -98zM550 355q0 104 -55.5 162.5t-168.5 58.5h-105v-442h105q113 0 168.5 58.5t55.5 162.5zM333 750l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcaron",
    unicode: "\u010F",
    horizAdvX: 635,
    d: "M428 468v282h142v-750h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q52 0 92.5 -19.5t62.5 -48.5zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107zM659 750h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5 t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Dcroat",
    unicode: "\u0110",
    horizAdvX: 746,
    d: "M330 0h-255v288h-70v134h70v288h255q177 0 275.5 -98t98.5 -257t-98.5 -257t-275.5 -98zM550 355q0 103 -55.5 160.5t-168.5 57.5h-105v-151h173v-134h-173v-151h105q113 0 168.5 57.5t55.5 160.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dcroat",
    unicode: "\u0111",
    horizAdvX: 635,
    d: "M428 468v111h-138v110h138v61h142v-61h65v-110h-65v-579h-131v64q-52 -76 -166 -76q-111 0 -176 78t-65 196t65 196t176 78q52 0 92.5 -19.5t62.5 -48.5zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Emacron",
    unicode: "\u0112",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM518 878v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emacron",
    unicode: "\u0113",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM484 720v-108h-373v108 h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ebreve",
    unicode: "\u0114",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM328 839q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ebreve",
    unicode: "\u0115",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM293 674q67 0 67 74h99 q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edotaccent",
    unicode: "\u0116",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM334 761q-38 0 -62 24t-24 61q0 38 24 62t62 24t62 -24t24 -62q0 -37 -24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edotaccent",
    unicode: "\u0117",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM293 592q-38 0 -62 24 t-24 61t24.5 61.5t61.5 24.5t61.5 -24.5t24.5 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eogonek",
    unicode: "\u0118",
    horizAdvX: 636,
    d: "M541 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 54 25 93h-336v710h511v-134h-365v-149h350v-134h-350v-159h365v-134h-55q-50 -36 -50 -86q0 -16 9 -26t26 -10q14 0 25 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eogonek",
    unicode: "\u0119",
    horizAdvX: 586,
    d: "M370 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5t21 87q-92 19 -148 92t-56 177q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5l-2 -42h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-20 -67 -71 -113.5t-121 -59.5q-42 -35 -42 -80 q0 -16 9 -26t26 -10q15 0 25 7zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecaron",
    unicode: "\u011A",
    horizAdvX: 636,
    d: "M586 134v-134h-511v710h511v-134h-365v-149h350v-134h-350v-159h365zM328 750l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecaron",
    unicode: "\u011B",
    horizAdvX: 586,
    d: "M553 221h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-116 0 -190 77t-74 198q0 117 74 195t189 78t187.5 -77.5t72.5 -195.5zM294 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM293 560l-161 83v112 l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcircumflex",
    unicode: "\u011C",
    horizAdvX: 800,
    d: "M452 262v131h305q1 -15 1 -37q0 -164 -101 -265.5t-252 -101.5q-160 0 -261.5 101t-101.5 266q0 164 103.5 266.5t259.5 102.5q130 0 224.5 -73.5t119.5 -192.5h-157q-16 59 -67 93t-120 34q-97 0 -153 -62t-56 -168q0 -105 56.5 -168.5t152.5 -63.5q73 0 125.5 37 t71.5 101h-150zM239 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcircumflex",
    unicode: "\u011D",
    horizAdvX: 626,
    d: "M435 460v64h131v-504q0 -105 -68 -172t-185 -67q-111 0 -172.5 59t-68.5 132h142q14 -69 101 -69q53 0 81 27t28 75v73q-51 -68 -153 -68q-107 0 -173 75.5t-66 187.5t66 187.5t173 75.5q112 0 164 -76zM428 273q0 62 -35 100t-92 38t-92 -38t-35 -100t35 -100t92 -38 t92 38t35 100zM160 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gbreve",
    unicode: "\u011E",
    horizAdvX: 800,
    d: "M452 262v131h305q1 -15 1 -37q0 -164 -101 -265.5t-252 -101.5q-160 0 -261.5 101t-101.5 266q0 164 103.5 266.5t259.5 102.5q130 0 224.5 -73.5t119.5 -192.5h-157q-16 59 -67 93t-120 34q-97 0 -153 -62t-56 -168q0 -105 56.5 -168.5t152.5 -63.5q73 0 125.5 37 t71.5 101h-150zM398 840q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gbreve",
    unicode: "\u011F",
    horizAdvX: 626,
    d: "M435 460v64h131v-504q0 -105 -68 -172t-185 -67q-111 0 -172.5 59t-68.5 132h142q14 -69 101 -69q53 0 81 27t28 75v73q-51 -68 -153 -68q-107 0 -173 75.5t-66 187.5t66 187.5t173 75.5q112 0 164 -76zM428 273q0 62 -35 100t-92 38t-92 -38t-35 -100t35 -100t92 -38 t92 38t35 100zM330 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gdotaccent",
    unicode: "\u0120",
    horizAdvX: 800,
    d: "M452 262v131h305q1 -15 1 -37q0 -164 -101 -265.5t-252 -101.5q-160 0 -261.5 101t-101.5 266q0 164 103.5 266.5t259.5 102.5q130 0 224.5 -73.5t119.5 -192.5h-157q-16 59 -67 93t-120 34q-97 0 -153 -62t-56 -168q0 -105 56.5 -168.5t152.5 -63.5q73 0 125.5 37 t71.5 101h-150zM400 760q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gdotaccent",
    unicode: "\u0121",
    horizAdvX: 626,
    d: "M435 460v64h131v-504q0 -105 -68 -172t-185 -67q-111 0 -172.5 59t-68.5 132h142q14 -69 101 -69q53 0 81 27t28 75v73q-51 -68 -153 -68q-107 0 -173 75.5t-66 187.5t66 187.5t173 75.5q112 0 164 -76zM428 273q0 62 -35 100t-92 38t-92 -38t-35 -100t35 -100t92 -38 t92 38t35 100zM329 592q-38 0 -62 24t-24 61t24.5 61.5t61.5 24.5t61.5 -24.5t24.5 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Gcommaaccent",
    unicode: "\u0122",
    horizAdvX: 800,
    d: "M452 262v131h305q1 -15 1 -37q0 -164 -101 -265.5t-252 -101.5q-160 0 -261.5 101t-101.5 266q0 164 103.5 266.5t259.5 102.5q130 0 224.5 -73.5t119.5 -192.5h-157q-16 59 -67 93t-120 34q-97 0 -153 -62t-56 -168q0 -105 56.5 -168.5t152.5 -63.5q73 0 125.5 37 t71.5 101h-150zM342 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "gcommaaccent",
    unicode: "\u0123",
    horizAdvX: 626,
    d: "M435 460v64h131v-504q0 -105 -68 -172t-185 -67q-111 0 -172.5 59t-68.5 132h142q14 -69 101 -69q53 0 81 27t28 75v73q-51 -68 -153 -68q-107 0 -173 75.5t-66 187.5t66 187.5t173 75.5q112 0 164 -76zM428 273q0 62 -35 100t-92 38t-92 -38t-35 -100t35 -100t92 -38 t92 38t35 100zM379 611h-120q-3 15 -3 43q0 36 12 67t29 50.5t34 33.5t29 20l12 6l69 -82q-3 -1 -7.5 -3.5t-16 -11t-20.5 -18.5t-16.5 -26t-7.5 -34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hcircumflex",
    unicode: "\u0124",
    horizAdvX: 739,
    d: "M664 710v-710h-146v293h-297v-293h-146v710h146v-283h297v283h146zM208 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hcircumflex",
    unicode: "\u0125",
    horizAdvX: 605,
    d: "M207 750v-274q45 60 145 60q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -84.5v-299h-142v750h142zM-22 858l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Hbar",
    unicode: "\u0126",
    horizAdvX: 739,
    d: "M664 710v-95h60v-108h-60v-507h-146v293h-297v-293h-146v507h-60v108h60v95h146v-95h297v95h146zM221 427h297v80h-297v-80z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hbar",
    unicode: "\u0127",
    horizAdvX: 605,
    d: "M207 750v-61h138v-110h-138v-103q45 60 145 60q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -84.5v-299h-142v579h-65v110h65v61h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Itilde",
    unicode: "\u0128",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM216 766q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "itilde",
    unicode: "\u0129",
    horizAdvX: 272,
    d: "M204 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Imacron",
    unicode: "\u012A",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM335 878v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "imacron",
    unicode: "\u012B",
    horizAdvX: 272,
    d: "M323 720v-108h-373v108h373zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ibreve",
    unicode: "\u012C",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM148 840q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ibreve",
    unicode: "\u012D",
    horizAdvX: 272,
    d: "M136 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74zM207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iogonek",
    unicode: "\u012E",
    horizAdvX: 296,
    d: "M176 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 78 54 128v675h146v-710h-55q-50 -36 -50 -86q0 -16 9 -26t26 -10q15 0 25 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iogonek",
    unicode: "\u012F",
    horizAdvX: 272,
    d: "M192 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 56 28 97v520h142v-524h-25q-50 -36 -50 -86q0 -16 9 -26t26 -10q15 0 25 7zM136 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idotaccent",
    unicode: "\u0130",
    horizAdvX: 296,
    d: "M221 710v-710h-146v710h146zM148 760q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotlessi",
    unicode: "\u0131",
    horizAdvX: 272,
    d: "M207 524v-524h-142v524h142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Jcircumflex",
    unicode: "\u0134",
    horizAdvX: 580,
    d: "M369 229v481h146v-477q0 -112 -67 -179t-180 -67q-111 0 -178.5 61t-67.5 169l3 48h146q-3 -18 -3 -48q0 -48 27 -74.5t73 -26.5q49 0 75 30.5t26 82.5zM283 861l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "jcircumflex",
    unicode: "\u0135",
    horizAdvX: 272,
    d: "M-25 672l161 83l161 -83v-112l-161 79l-161 -79v112zM65 -208v732h142v-732h-142z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Kcommaaccent",
    unicode: "\u0136",
    horizAdvX: 693,
    d: "M711 0h-180l-202 305l-108 -118v-187h-146v710h146v-338l289 338h190l-270 -295zM305 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "kcommaaccent",
    unicode: "\u0137",
    horizAdvX: 570,
    d: "M398 524h178l-196 -223l210 -301h-168l-136 207l-79 -90v-117h-142v750h142v-464zM254 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lacute",
    unicode: "\u0139",
    horizAdvX: 547,
    d: "M536 134v-134h-461v710h146v-576h315zM142 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lacute",
    unicode: "\u013A",
    horizAdvX: 272,
    d: "M207 0h-142v750h142v-750zM134 981h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcommaaccent",
    unicode: "\u013B",
    horizAdvX: 547,
    d: "M536 134v-134h-461v710h146v-576h315zM257 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcommaaccent",
    unicode: "\u013C",
    horizAdvX: 272,
    d: "M207 0h-142v750h142v-750zM74 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lcaron",
    unicode: "\u013D",
    horizAdvX: 547,
    d: "M536 134v-134h-461v710h146v-576h315zM342 710h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lcaron",
    unicode: "\u013E",
    horizAdvX: 272,
    d: "M207 0h-142v750h142v-750zM297 750h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Lslash",
    unicode: "\u0141",
    horizAdvX: 547,
    d: "M536 134v-134h-461v240l-70 -18v121l70 18v349h146v-310l88 23v-121l-88 -23v-145h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lslash",
    unicode: "\u0142",
    horizAdvX: 272,
    d: "M207 0h-142v242l-71 -20v117l71 20v391h142v-351l71 20v-117l-71 -20v-282z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Nacute",
    unicode: "\u0143",
    horizAdvX: 749,
    d: "M217 469v-469h-142v710h147l310 -469v469h142v-710h-147zM372 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nacute",
    unicode: "\u0144",
    horizAdvX: 605,
    d: "M196 524v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131zM293 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncommaaccent",
    unicode: "\u0145",
    horizAdvX: 749,
    d: "M217 469v-469h-142v710h147l310 -469v469h142v-710h-147zM319 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncommaaccent",
    unicode: "\u0146",
    horizAdvX: 605,
    d: "M196 524v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131zM251 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ncaron",
    unicode: "\u0147",
    horizAdvX: 749,
    d: "M217 469v-469h-142v710h147l310 -469v469h142v-710h-147zM374 749l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ncaron",
    unicode: "\u0148",
    horizAdvX: 605,
    d: "M196 524v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-327h-142v311q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131zM302 560l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eng",
    unicode: "\u014A",
    horizAdvX: 749,
    d: "M532 2l-315 467v-469h-142v710h147l310 -460v460h142v-665q0 -103 -49 -175t-149 -94l-53 111q56 14 82.5 38.5t26.5 76.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eng",
    unicode: "\u014B",
    horizAdvX: 605,
    d: "M403 44v267q0 103 -89 103q-51 0 -79 -30.5t-28 -83.5v-300h-142v524h131v-64q41 76 156 76q93 0 143 -56.5t50 -152.5v-252q0 -103 -49 -175t-149 -94l-53 111q109 28 109 127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Omacron",
    unicode: "\u014C",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM597 878v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "omacron",
    unicode: "\u014D",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM493 720v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Obreve",
    unicode: "\u014E",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM411 839q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43 t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "obreve",
    unicode: "\u014F",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM307 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43 t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ohungarumlaut",
    unicode: "\u0150",
    horizAdvX: 822,
    d: "M780 355q0 -160 -104 -265t-265 -105t-265 105t-104 265t104 265t265 105t265 -105t104 -265zM626 355q0 104 -60 167.5t-155 63.5t-155 -63.5t-60 -167.5t60 -167.5t155 -63.5t155 63.5t60 167.5zM316 942h147l-90 -171h-118zM501 942h147l-90 -171h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ohungarumlaut",
    unicode: "\u0151",
    horizAdvX: 614,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5t199 -79.5t76 -194.5t-76 -194.5t-199 -79.5zM174 262q0 -69 37.5 -109t95.5 -40t95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109zM201 750h147l-90 -171h-118zM386 750h147l-90 -171h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1181,
    d: "M1131 134v-134h-511v57q-86 -72 -212 -72q-156 0 -261 102.5t-105 267.5t105 267.5t261 102.5q127 0 212 -73v58h511v-134h-365v-149h350v-134h-350v-159h365zM408 590q-97 0 -154.5 -63.5t-57.5 -171.5t57.5 -171.5t154.5 -63.5t154.5 63.5t57.5 171.5t-57.5 171.5 t-154.5 63.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 994,
    d: "M307 -12q-123 0 -199 79.5t-76 194.5t76 194.5t199 79.5q124 0 202 -83q76 83 194 83q115 0 187.5 -77.5t72.5 -195.5l-2 -42h-380q7 -54 40 -82.5t87 -28.5q34 0 61.5 14.5t39.5 42.5h143q-23 -80 -90.5 -129.5t-157.5 -49.5q-121 0 -195 82q-77 -82 -202 -82zM583 323 h238q-8 45 -39 72t-80 27q-48 0 -79 -26.5t-40 -72.5zM307 113q58 0 95.5 40t37.5 109t-37.5 109t-95.5 40t-95.5 -40t-37.5 -109t37.5 -109t95.5 -40z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Racute",
    unicode: "\u0154",
    horizAdvX: 674,
    d: "M663 0h-169l-133 269h-140v-269h-146v710h322q113 0 175 -61t62 -161q0 -72 -32.5 -125t-93.5 -78zM488 488q0 40 -23.5 64t-67.5 24h-176v-173h176q45 0 68 22.5t23 62.5zM324 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "racute",
    unicode: "\u0155",
    horizAdvX: 373,
    d: "M361 528v-133q-15 3 -28 3q-63 0 -94.5 -33t-31.5 -104v-261h-142v524h131v-68q45 73 148 73zM188 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcommaaccent",
    unicode: "\u0156",
    horizAdvX: 674,
    d: "M663 0h-169l-133 269h-140v-269h-146v710h322q113 0 175 -61t62 -161q0 -72 -32.5 -125t-93.5 -78zM488 488q0 40 -23.5 64t-67.5 24h-176v-173h176q45 0 68 22.5t23 62.5zM296 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82 q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcommaaccent",
    unicode: "\u0157",
    horizAdvX: 373,
    d: "M361 528v-133q-15 3 -28 3q-63 0 -94.5 -33t-31.5 -104v-261h-142v524h131v-68q45 73 148 73zM74 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Rcaron",
    unicode: "\u0158",
    horizAdvX: 674,
    d: "M663 0h-169l-133 269h-140v-269h-146v710h322q113 0 175 -61t62 -161q0 -72 -32.5 -125t-93.5 -78zM488 488q0 40 -23.5 64t-67.5 24h-176v-173h176q45 0 68 22.5t23 62.5zM335 751l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "rcaron",
    unicode: "\u0159",
    horizAdvX: 373,
    d: "M361 528v-133q-15 3 -28 3q-63 0 -94.5 -33t-31.5 -104v-261h-142v524h131v-68q45 73 148 73zM207 560l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Sacute",
    unicode: "\u015A",
    horizAdvX: 643,
    d: "M317 116q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5 t21 -98q0 -96 -77.5 -156.5t-203.5 -60.5q-71 0 -125 20.5t-85 55.5t-46.5 76t-17.5 87h144q3 -47 38 -78t100 -31zM312 942h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sacute",
    unicode: "\u015B",
    horizAdvX: 501,
    d: "M251 -12q-214 0 -227 182h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5 t72.5 -48t30 -96q0 -73 -59.5 -120.5t-162.5 -47.5zM248 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scircumflex",
    unicode: "\u015C",
    horizAdvX: 643,
    d: "M317 116q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5 t21 -98q0 -96 -77.5 -156.5t-203.5 -60.5q-71 0 -125 20.5t-85 55.5t-46.5 76t-17.5 87h144q3 -47 38 -78t100 -31zM162 863l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scircumflex",
    unicode: "\u015D",
    horizAdvX: 501,
    d: "M251 -12q-214 0 -227 182h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5 t72.5 -48t30 -96q0 -73 -59.5 -120.5t-162.5 -47.5zM101 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scedilla",
    unicode: "\u015E",
    horizAdvX: 643,
    d: "M244 -216l37 61q22 -21 57 -21q41 0 41 34q0 33 -40 33q-8 0 -15.5 -2.5t-11.5 -4.5l-3 -3l-44 25l21 81q-65 3 -114 24.5t-77.5 56t-43 73.5t-16.5 84h144q3 -47 38 -78t100 -31q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5 q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5t21 -98q0 -87 -64.5 -146t-172.5 -69l-9 -34q4 2 22 2q41 0 67 -26.5t26 -68.5q0 -51 -32 -80 t-81 -29q-32 0 -57.5 8t-34.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scedilla",
    unicode: "\u015F",
    horizAdvX: 501,
    d: "M180 -216l37 61q22 -21 57 -21q41 0 41 34q0 33 -40 33q-8 0 -15.5 -2.5t-11.5 -4.5l-3 -3l-44 25l22 83q-188 12 -199 181h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54 t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5t72.5 -48t30 -96q0 -65 -49 -111t-135 -55l-9 -36q4 2 22 2q41 0 67 -26.5t26 -68.5q0 -51 -32 -80t-81 -29q-32 0 -57.5 8t-34.5 16z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scaron",
    unicode: "\u0160",
    horizAdvX: 643,
    d: "M317 116q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5 t21 -98q0 -96 -77.5 -156.5t-203.5 -60.5q-71 0 -125 20.5t-85 55.5t-46.5 76t-17.5 87h144q3 -47 38 -78t100 -31zM320 750l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scaron",
    unicode: "\u0161",
    horizAdvX: 501,
    d: "M251 -12q-214 0 -227 182h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5 t72.5 -48t30 -96q0 -73 -59.5 -120.5t-162.5 -47.5zM260 560l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcommaaccent",
    unicode: "\u0162",
    horizAdvX: 546,
    d: "M541 710v-137h-195v-573h-146v573h-195v137h536zM212 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcommaaccent",
    unicode: "\u0163",
    horizAdvX: 312,
    d: "M225 412v-412h-142v412h-71v112h71v130h142v-130h77v-112h-77zM125 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tcaron",
    unicode: "\u0164",
    horizAdvX: 546,
    d: "M541 710v-137h-195v-573h-146v573h-195v137h536zM273 751l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tcaron",
    unicode: "\u0165",
    horizAdvX: 312,
    d: "M225 412v-412h-142v412h-71v112h71v130h142v-130h77v-112h-77zM302 750h113q3 -14 3 -38q0 -31 -11 -58.5t-27 -44.5t-32.5 -29.5t-27.5 -17.5l-11 -5l-66 72q3 1 7 3t15.5 9.5t20 16t15.5 23t7 29.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Tbar",
    unicode: "\u0166",
    horizAdvX: 546,
    d: "M541 710v-137h-195v-161h113v-108h-113v-304h-146v304h-114v108h114v161h-195v137h536z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tbar",
    unicode: "\u0167",
    horizAdvX: 312,
    d: "M225 412v-67h74v-110h-74v-235h-142v235h-55v110h55v67h-71v112h71v130h142v-130h77v-112h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Utilde",
    unicode: "\u0168",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM438 766q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84 q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "utilde",
    unicode: "\u0169",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM371 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Umacron",
    unicode: "\u016A",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM557 878v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "umacron",
    unicode: "\u016B",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM487 720v-108h-373v108h373z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ubreve",
    unicode: "\u016C",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM371 840q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ubreve",
    unicode: "\u016D",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM300 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uring",
    unicode: "\u016E",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM323 860q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14t-13 -36zM246 860q0 53 35 88.5t90 35.5t90 -35.5t35 -88.5 t-35 -88.5t-90 -35.5t-90 35.5t-35 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uring",
    unicode: "\u016F",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM252 695q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14t-13 -36zM175 695q0 53 35 88.5t90 35.5t90 -35.5t35 -88.5t-35 -88.5t-90 -35.5 t-90 35.5t-35 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uhungarumlaut",
    unicode: "\u0170",
    horizAdvX: 742,
    d: "M371 -15q-129 0 -215 79t-86 228v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -149 -86 -228t-215 -79zM270 941h147l-90 -171h-118zM455 941h147l-90 -171h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uhungarumlaut",
    unicode: "\u0171",
    horizAdvX: 596,
    d: "M298 -12q-118 0 -178 56t-60 180v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -124 -60 -180t-178 -56zM187 750h147l-90 -171h-118zM372 750h147l-90 -171h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uogonek",
    unicode: "\u0172",
    horizAdvX: 742,
    d: "M442 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 47 19 84q-105 18 -170.5 94.5t-65.5 206.5v418h146v-422q0 -78 38.5 -123t116.5 -45t116.5 45t38.5 123v422h146v-418q0 -135 -71 -212.5t-184 -91.5q-35 -31 -35 -74q0 -16 9 -26t26 -10q14 0 25 7z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uogonek",
    unicode: "\u0173",
    horizAdvX: 596,
    d: "M391 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 48 19 83q-97 9 -146 65t-49 169v300h142v-302q0 -107 96 -107t96 107v302h142v-300q0 -196 -161 -229q-44 -34 -44 -81q0 -16 9 -26t26 -10q14 0 25 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wcircumflex",
    unicode: "\u0174",
    horizAdvX: 1046,
    d: "M522 502l-144 -502h-154l-218 710h164l132 -502h2l142 502h158l142 -502h2l132 502h160l-218 -710h-154l-144 502h-2zM362 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wcircumflex",
    unicode: "\u0175",
    horizAdvX: 847,
    d: "M531 0l-106 324h-2l-107 -324h-133l-183 524h147l105 -345l108 345h128l109 -347l106 347h144l-183 -524h-133zM262 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ycircumflex",
    unicode: "\u0176",
    horizAdvX: 638,
    d: "M485 710h169l-262 -462v-248h-146v248l-262 462h169l165 -313h2zM158 862l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ycircumflex",
    unicode: "\u0177",
    horizAdvX: 552,
    d: "M119 -208l88 217l-207 515h151l126 -350l127 350h148l-293 -732h-140zM115 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 638,
    d: "M485 710h169l-262 -462v-248h-146v248l-262 462h169l165 -313h2zM228 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM410 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zacute",
    unicode: "\u0179",
    horizAdvX: 668,
    d: "M620 710v-128l-386 -448h390v-134h-580v128l386 448h-382v134h572zM321 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zacute",
    unicode: "\u017A",
    horizAdvX: 545,
    d: "M491 407l-263 -284h267v-123h-445v117l262 284h-258v123h437v-117zM264 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zdotaccent",
    unicode: "\u017B",
    horizAdvX: 668,
    d: "M620 710v-128l-386 -448h390v-134h-580v128l386 448h-382v134h572zM334 760q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zdotaccent",
    unicode: "\u017C",
    horizAdvX: 545,
    d: "M491 407l-263 -284h267v-123h-445v117l262 284h-258v123h437v-117zM272 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Zcaron",
    unicode: "\u017D",
    horizAdvX: 668,
    d: "M620 710v-128l-386 -448h390v-134h-580v128l386 448h-382v134h572zM333 750l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zcaron",
    unicode: "\u017E",
    horizAdvX: 545,
    d: "M491 407l-263 -284h267v-123h-445v117l262 284h-258v123h437v-117zM274 560l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin",
    unicode: "\u0192",
    d: "M349 323l-65 -331q-16 -79 -64 -120.5t-125 -41.5q-22 0 -45 5t-36 11l-12 5l46 116q20 -11 43 -11q45 0 55 51l61 316h-74l23 123h75l29 142q16 79 64 120.5t125 41.5q22 0 45 -5t36 -11l12 -5l-46 -116q-20 11 -43 11q-45 0 -55 -51l-25 -127h73l-23 -123h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aringacute",
    unicode: "\u01FA",
    horizAdvX: 688,
    d: "M153 0h-153l267 710h154l267 -710h-157l-43 122h-292zM221 860q0 41 22.5 73t60.5 44l43 120h116l-59 -126q31 -16 49 -45.5t18 -65.5q0 -53 -35 -88.5t-90 -35.5t-90 35.5t-35 88.5zM343 530h-2l-98 -277h198zM298 860q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14 t-35 -14t-13 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aringacute",
    unicode: "\u01FB",
    horizAdvX: 635,
    d: "M185 695q0 41 22.5 73t60.5 44l43 120h116l-59 -126q31 -16 49 -45.5t18 -65.5q0 -53 -35 -88.5t-90 -35.5t-90 35.5t-35 88.5zM262 695q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14t-13 -36zM439 524h131v-524h-131v64q-52 -76 -166 -76q-111 0 -176 78 t-65 196t65 196t176 78q114 0 166 -76v64zM432 262q0 65 -35.5 107t-93.5 42t-93.5 -42t-35.5 -107t35.5 -107t93.5 -42t93.5 42t35.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AEacute",
    unicode: "\u01FC",
    horizAdvX: 988,
    d: "M141 0h-163l372 710h588v-134h-365v-149h350v-134h-350v-159h365v-134h-511v122h-225zM425 563l-157 -310h159v310h-2zM567 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aeacute",
    unicode: "\u01FD",
    horizAdvX: 931,
    d: "M232 -12q-95 0 -144.5 45t-49.5 115q0 69 49.5 110.5t153.5 57.5l136 21v5q0 38 -25 57.5t-69 19.5q-84 0 -93 -64h-140q7 77 64 129t172 52q123 0 182 -62q72 62 172 62q115 0 187.5 -77.5t72.5 -195.5l-2 -42h-380q7 -54 40 -82.5t87 -28.5q75 0 101 57h143 q-23 -80 -90.5 -129.5t-157.5 -49.5q-128 0 -203 91q-62 -91 -206 -91zM254 98q60 0 91.5 31.5t31.5 85.5v21l-122 -21q-80 -14 -80 -62q0 -55 79 -55zM639 422q-48 0 -79 -26.5t-40 -72.5h238q-8 45 -39 72t-80 27zM462 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslashacute",
    unicode: "\u01FE",
    horizAdvX: 822,
    d: "M409 942h147l-80 -171h-128zM780 355q0 -160 -104 -265t-265 -105q-124 0 -216 64l-78 -87l-61 56l76 86q-90 103 -90 251q0 160 104 265t265 105q121 0 215 -64l78 87l62 -57l-77 -86q91 -102 91 -250zM626 355q0 77 -37 137l-298 -335q49 -33 120 -33q95 0 155 63.5 t60 167.5zM196 355q0 -81 37 -138l297 335q-51 34 -119 34q-95 0 -155 -63.5t-60 -167.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslashacute",
    unicode: "\u01FF",
    horizAdvX: 614,
    d: "M296 760h147l-80 -171h-128zM307 -12q-91 0 -159 46l-55 -63l-50 45l55 62q-66 75 -66 184q0 115 76 194.5t199 79.5q87 0 154 -43l54 61l50 -45l-52 -60q69 -77 69 -187q0 -115 -76 -194.5t-199 -79.5zM440 262q0 47 -19 82l-186 -211q32 -20 72 -20q58 0 95.5 40 t37.5 109zM174 262q0 -44 16 -78l184 209q-28 18 -67 18q-58 0 -95.5 -40t-37.5 -109z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Scommaaccent",
    unicode: "\u0218",
    horizAdvX: 643,
    d: "M317 116q59 0 92 21.5t33 60.5q0 28 -21 46t-54.5 28t-74 18.5t-81 22t-74 35t-54.5 62t-21 96.5q0 93 70 156t189 63q120 0 190.5 -68t73.5 -169h-143q-2 48 -34.5 77.5t-88.5 29.5q-51 0 -82 -22.5t-31 -57.5q0 -29 21 -47t55 -28t75 -18.5t82 -22.5t75 -35.5t55 -62.5 t21 -98q0 -96 -77.5 -156.5t-203.5 -60.5q-71 0 -125 20.5t-85 55.5t-46.5 76t-17.5 87h144q3 -47 38 -78t100 -31zM270 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "scommaaccent",
    unicode: "\u0219",
    horizAdvX: 501,
    d: "M251 -12q-214 0 -227 182h144q2 -29 23.5 -48.5t63.5 -19.5q40 0 61 13t21 35q0 24 -30 35.5t-72.5 18.5t-85.5 19t-73 47t-30 93q0 73 58 123t152 50q107 0 159 -54t56 -123h-137q-2 27 -22.5 45t-56.5 18q-34 0 -53 -14.5t-19 -36.5q0 -24 30 -35t72.5 -17.5t85 -18.5 t72.5 -48t30 -96q0 -73 -59.5 -120.5t-162.5 -47.5zM201 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    horizAdvX: 490,
    d: "M86 672l161 83l161 -83v-112l-161 79l-161 -79v112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "caron",
    unicode: "\u02C7",
    horizAdvX: 490,
    d: "M247 560l-161 83v112l161 -79l161 79v-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "breve",
    unicode: "\u02D8",
    horizAdvX: 398,
    d: "M199 674q67 0 67 74h99q0 -77 -44.5 -120t-121.5 -43t-121.5 43t-44.5 120h99q0 -74 67 -74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dotaccent",
    unicode: "\u02D9",
    horizAdvX: 272,
    d: "M136 592q-38 0 -62 24t-24 61t24 61.5t62 24.5t62 -24.5t24 -61.5t-24 -61t-62 -24z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ring",
    unicode: "\u02DA",
    horizAdvX: 310,
    d: "M110 695q0 -22 13 -36t35 -14t35 14t13 36t-13 36t-35 14t-35 -14t-13 -36zM33 695q0 53 35 88.5t90 35.5t90 -35.5t35 -88.5t-35 -88.5t-90 -35.5t-90 35.5t-35 88.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ogonek",
    unicode: "\u02DB",
    horizAdvX: 252,
    d: "M188 -115l31 -72q-30 -21 -75 -21q-50 0 -80.5 32.5t-30.5 82.5q0 101 94 158l59 -60q-58 -39 -58 -91q0 -16 9 -26t26 -10q15 0 25 7z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    horizAdvX: 431,
    d: "M283 600q-33 0 -77 18.5t-65 18.5q-32 0 -35 -33h-84q2 59 35 95.5t92 36.5q33 0 77 -18.5t65 -18.5q31 0 34 33h84q-2 -59 -35 -95.5t-91 -36.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hungarumlaut",
    unicode: "\u02DD",
    horizAdvX: 459,
    d: "M94 750h147l-90 -171h-118zM279 750h147l-90 -171h-118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "pi",
    unicode: "\u03C0",
    horizAdvX: 759,
    d: "M23 356q0 157 105 263t264 106t264 -106t105 -263t-105 -263t-264 -106t-264 106t-105 263zM131 356q0 -119 72 -195t189 -76t189 76t72 195t-72 195t-189 76t-189 -76t-72 -195zM251 162v377h174q73 0 111.5 -39t38.5 -99q0 -59 -39.5 -98t-110.5 -39h-70v-102h-104z M355 355h64q52 0 52 46t-52 46h-64v-92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wgrave",
    unicode: "\u1E80",
    horizAdvX: 1046,
    d: "M522 502l-144 -502h-154l-218 710h164l132 -502h2l142 502h158l142 -502h2l132 502h160l-218 -710h-154l-144 502h-2zM383 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wgrave",
    unicode: "\u1E81",
    horizAdvX: 847,
    d: "M531 0l-106 324h-2l-107 -324h-133l-183 524h147l105 -345l108 345h128l109 -347l106 347h144l-183 -524h-133zM279 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wacute",
    unicode: "\u1E82",
    horizAdvX: 1046,
    d: "M522 502l-144 -502h-154l-218 710h164l132 -502h2l142 502h158l142 -502h2l132 502h160l-218 -710h-154l-144 502h-2zM523 941h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wacute",
    unicode: "\u1E83",
    horizAdvX: 847,
    d: "M531 0l-106 324h-2l-107 -324h-133l-183 524h147l105 -345l108 345h128l109 -347l106 347h144l-183 -524h-133zM422 760h147l-80 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Wdieresis",
    unicode: "\u1E84",
    horizAdvX: 1046,
    d: "M522 502l-144 -502h-154l-218 710h164l132 -502h2l142 502h158l142 -502h2l132 502h160l-218 -710h-154l-144 502h-2zM432 760q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM614 760q-33 0 -54 21t-21 53q0 33 21 54t54 21 q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "wdieresis",
    unicode: "\u1E85",
    horizAdvX: 847,
    d: "M531 0l-106 324h-2l-107 -324h-133l-183 524h147l105 -345l108 345h128l109 -347l106 347h144l-183 -524h-133zM332 603q-33 0 -54 21t-21 53q0 33 21 54t54 21q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21zM514 603q-33 0 -54 21t-21 53q0 33 21 54t54 21 q32 0 53.5 -21t21.5 -54q0 -32 -21.5 -53t-53.5 -21z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ygrave",
    unicode: "\u1EF2",
    horizAdvX: 638,
    d: "M485 710h169l-262 -462v-248h-146v248l-262 462h169l165 -313h2zM182 941h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ygrave",
    unicode: "\u1EF3",
    horizAdvX: 552,
    d: "M119 -208l88 217l-207 515h151l126 -350l127 350h148l-293 -732h-140zM142 760h147l61 -171h-128z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M500 329v-134h-500v134h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M1000 329v-134h-1000v134h1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 257,
    d: "M167 426h-145l96 284h117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 257,
    d: "M90 710h145l-96 -284h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 257,
    d: "M90 161h145l-96 -284h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 465,
    d: "M375 426h-145l96 284h117zM167 426h-145l96 284h117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 465,
    d: "M90 710h145l-96 -284h-117zM298 710h145l-96 -284h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 465,
    d: "M90 161h145l-96 -284h-117zM298 161h145l-96 -284h-117z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dagger",
    unicode: "\u2020",
    horizAdvX: 539,
    d: "M340 -80h-142v477h-164v127h164v186h142v-186h165v-127h-165v-477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "daggerdbl",
    unicode: "\u2021",
    horizAdvX: 539,
    d: "M198 710h142v-186h165v-127h-165v-164h165v-127h-165v-186h-142v186h-164v127h164v164h-164v127h164v186z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 517,
    d: "M111 357q0 62 43 105t104 43q62 0 105 -43.5t43 -104.5t-43 -104t-105 -43t-104.5 43t-42.5 104z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 768,
    d: "M124 -8q-40 0 -65 24.5t-25 64.5q0 39 25 64.5t65 25.5q39 0 64.5 -25.5t25.5 -64.5t-25.5 -64t-64.5 -25zM384 -8q-40 0 -65 24.5t-25 64.5q0 39 25 64.5t65 25.5q39 0 64.5 -25.5t25.5 -64.5t-25.5 -64t-64.5 -25zM644 -8q-40 0 -65 24.5t-25 64.5q0 39 25 64.5 t65 25.5q39 0 64.5 -25.5t25.5 -64.5t-25.5 -64t-64.5 -25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "perthousand",
    unicode: "\u2030",
    horizAdvX: 1341,
    d: "M234 0l392 710h103l-392 -710h-103zM186 489q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM76 489q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5zM665 220 q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM555 220q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5zM1043 220q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5 t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM933 220q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 336,
    d: "M44 262l108 216h140l-110 -216l110 -216h-140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 336,
    d: "M184 478l108 -216l-108 -216h-140l110 216l-110 216h140z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fraction",
    unicode: "\u2044",
    horizAdvX: 407,
    d: "M-44 0l392 710h103l-392 -710h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zerosuperior",
    unicode: "\u2070",
    horizAdvX: 406,
    d: "M147 652q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM37 652q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "foursuperior",
    unicode: "\u2074",
    horizAdvX: 398,
    d: "M372 612v-91h-56v-85h-98v85h-190v89l180 259h108v-257h56zM218 739l-88 -127h88v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fivesuperior",
    unicode: "\u2075",
    horizAdvX: 400,
    d: "M39 573h110q4 -49 49 -49q54 0 54 57q0 26 -14 41t-40 15q-19 0 -31 -8.5t-15 -16.5l-2 -9h-101l37 266h249v-102h-165l-7 -48q21 11 52 11q75 0 110.5 -44.5t35.5 -104.5q0 -69 -45.5 -112t-119.5 -43q-67 0 -109.5 40t-47.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixsuperior",
    unicode: "\u2076",
    horizAdvX: 391,
    d: "M172 869h137q-85 -90 -114 -137q7 1 22 1q69 0 107.5 -42.5t38.5 -108.5q0 -67 -44.5 -111.5t-117.5 -44.5q-76 0 -120 47t-44 118q0 121 135 278zM252 582q0 26 -14 42.5t-37 16.5t-37.5 -16.5t-14.5 -42.5t14.5 -42t37.5 -16q22 0 36.5 16t14.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sevensuperior",
    unicode: "\u2077",
    horizAdvX: 361,
    d: "M341 869v-96q-103 -142 -129 -337h-112q24 190 119 331h-87v-49h-106v151h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightsuperior",
    unicode: "\u2078",
    horizAdvX: 388,
    d: "M194 519q24 0 36.5 12t12.5 31q0 18 -12.5 31t-36.5 13t-36.5 -13t-12.5 -31q0 -19 12.5 -31t36.5 -12zM194 704q22 0 34 11t12 30q0 16 -12 27.5t-34 11.5t-34 -11.5t-12 -27.5q0 -19 12 -30t34 -11zM194 425q-73 0 -115 36t-42 95q0 68 50 102q-41 36 -41 90 q0 58 40.5 94t107.5 36t107.5 -36t40.5 -94q0 -54 -41 -90q50 -34 50 -102q0 -59 -42 -95t-115 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ninesuperior",
    unicode: "\u2079",
    horizAdvX: 391,
    d: "M219 436h-137q85 90 114 137q-7 -1 -22 -1q-69 0 -107.5 42.5t-38.5 108.5q0 67 44.5 111.5t117.5 44.5q76 0 120 -47t44 -118q0 -121 -135 -278zM139 723q0 -26 14 -42.5t37 -16.5t37.5 16.5t14.5 42.5t-14.5 42t-37.5 16q-22 0 -36.5 -16t-14.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zeroinferior",
    unicode: "\u2080",
    horizAdvX: 406,
    d: "M147 57q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM37 57q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oneinferior",
    unicode: "\u2081",
    horizAdvX: 292,
    d: "M220 275v-433h-109v325h-83v78l100 30h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "twoinferior",
    unicode: "\u2082",
    horizAdvX: 392,
    d: "M350 -159h-308v84l167 142q34 29 34 67q0 20 -12 34t-36 14q-23 0 -36 -13t-13 -37l2 -24h-108q-1 11 -1 25q0 66 45 108.5t111 42.5q69 0 113.5 -41.5t44.5 -101.5q0 -48 -17.5 -80.5t-59.5 -64.5l-69 -53h143v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threeinferior",
    unicode: "\u2083",
    horizAdvX: 389,
    d: "M144 10v90h44q25 0 38.5 12t13.5 33q0 16 -12.5 27.5t-32.5 11.5q-24 0 -37 -14t-13 -37h-106q0 63 42 107t114 44t111 -35t39 -93q0 -68 -54 -96q59 -26 59 -97q0 -57 -46 -94.5t-113 -37.5q-68 0 -108.5 38.5t-42.5 102.5h105q3 -41 46 -41q19 0 30.5 10.5t11.5 26.5 q0 42 -50 42h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fourinferior",
    unicode: "\u2084",
    horizAdvX: 398,
    d: "M372 17v-91h-56v-85h-98v85h-190v89l180 259h108v-257h56zM218 144l-88 -127h88v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "fiveinferior",
    unicode: "\u2085",
    horizAdvX: 400,
    d: "M39 -22h110q4 -49 49 -49q54 0 54 57q0 26 -14 41t-40 15q-19 0 -31 -8.5t-15 -17.5l-2 -8h-101l37 266h249v-102h-165l-7 -48q21 11 52 11q75 0 110.5 -44.5t35.5 -104.5q0 -69 -45.5 -112t-119.5 -43q-67 0 -109.5 40t-47.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sixinferior",
    unicode: "\u2086",
    horizAdvX: 391,
    d: "M172 274h137q-85 -90 -114 -137q7 1 22 1q69 0 107.5 -42.5t38.5 -108.5q0 -67 -44.5 -111.5t-117.5 -44.5q-76 0 -120 47t-44 118q0 121 135 278zM252 -13q0 26 -14 42.5t-37 16.5t-37.5 -16.5t-14.5 -42.5t14.5 -42t37.5 -16q22 0 36.5 16t14.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seveninferior",
    unicode: "\u2087",
    horizAdvX: 361,
    d: "M341 274v-96q-103 -142 -129 -337h-112q24 190 119 331h-87v-49h-106v151h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eightinferior",
    unicode: "\u2088",
    horizAdvX: 388,
    d: "M194 -75q24 0 36.5 12t12.5 31q0 18 -12.5 31t-36.5 13t-36.5 -13t-12.5 -31q0 -19 12.5 -31t36.5 -12zM194 110q22 0 34 11t12 30q0 16 -12 27.5t-34 11.5t-34 -11.5t-12 -27.5q0 -19 12 -30t34 -11zM194 -169q-73 0 -115 36t-42 95q0 68 50 102q-41 36 -41 90 q0 58 40.5 94t107.5 36t107.5 -36t40.5 -94q0 -54 -41 -90q50 -34 50 -102q0 -59 -42 -95t-115 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nineinferior",
    unicode: "\u2089",
    horizAdvX: 391,
    d: "M219 -159h-137q85 90 114 137q-7 -1 -22 -1q-69 0 -107.5 42.5t-38.5 108.5q0 67 44.5 111.5t117.5 44.5q76 0 120 -47t44 -118q0 -121 -135 -278zM139 128q0 -26 14 -42.5t37 -16.5t37.5 16.5t14.5 42.5t-14.5 42t-37.5 16q-22 0 -36.5 -16t-14.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    d: "M49 226v100h52q-1 19 -1 30l1 29h-52v100h65q29 118 110 179t196 61q31 0 61 -3.5t45 -7.5l14 -4v-132q-50 17 -120 17q-120 0 -157 -110h183v-100h-200q-1 -18 -1 -29q0 -21 1 -30h200v-100h-183q37 -109 157 -109q31 0 61 4t45 9l14 4v-132q-50 -15 -120 -15 q-115 0 -195.5 61t-109.5 178h-66z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 844,
    d: "M598 565l113 145h100v-410h-105v257l-106 -133h-4l-106 133v-257h-105v410h100zM343 710v-101h-112v-309h-108v309h-112v101h332z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "minus",
    unicode: "\u2212",
    d: "M553 329v-134h-524v134h524z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "approxequal",
    unicode: "\u2248",
    d: "M18 321q2 5 5.5 13t17.5 28t32 35.5t50 28t70 12.5q52 0 109 -23t88 -23q28 0 46 12t22 24l5 12l101 -61q-2 -5 -5.5 -13t-17.5 -28t-32 -35.5t-50 -28t-70 -12.5q-47 0 -106.5 23t-90.5 23q-28 0 -46 -12t-22 -24l-5 -12zM18 108q2 5 5.5 13t17.5 28t32 35.5t50 28 t70 12.5q52 0 109 -23t88 -23q28 0 46 12t22 24l5 12l101 -61q-2 -5 -5.5 -13t-17.5 -28t-32 -35.5t-50 -28t-70 -12.5q-47 0 -106.5 23t-90.5 23q-28 0 -46 -12t-22 -24l-5 -12z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "notequal",
    unicode: "\u2260",
    d: "M553 222v-134h-252l-33 -88h-152l33 88h-120v134h170l30 80h-200v134h251l33 88h152l-33 -88h121v-134h-172l-30 -80h202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "lessequal",
    unicode: "\u2264",
    d: "M211 0l-191 262l191 262h168l-151 -195h335v-134h-335l151 -195h-168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greaterequal",
    unicode: "\u2265",
    d: "M563 262l-191 -262h-168l151 195h-335v134h335l-151 195h168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen.cap",
    horizAdvX: 411,
    d: "M367 428v-134h-323v134h323z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown.cap",
    horizAdvX: 282,
    d: "M82 491h118l25 -492h-168zM141 717q39 0 64.5 -25t25.5 -64t-25.5 -64.5t-64.5 -25.5q-40 0 -65 25.5t-25 64.5q0 40 25 64.5t65 24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown.cap",
    horizAdvX: 532,
    d: "M499 197q0 -92 -64 -152t-169 -60q-110 0 -171.5 59t-61.5 151q0 45 18 83.5t44 63.5t52 46.5t44 44t18 45.5l-2 20h140q2 -13 2 -22q0 -44 -17.5 -80t-43 -59.5t-51 -44.5t-43 -44.5t-17.5 -48.5q0 -39 24 -61.5t64 -22.5t65.5 24.5t25.5 63.5l-6 53h142q7 -26 7 -59z M272 718q40 0 65 -24.5t25 -64.5q0 -39 -25 -64.5t-65 -25.5q-39 0 -64.5 25.5t-25.5 64.5t25.5 64t64.5 25z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash.cap",
    horizAdvX: 500,
    d: "M500 428v-134h-500v134h500z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash.cap",
    horizAdvX: 1000,
    d: "M1000 428v-134h-1000v134h1000z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered.cap",
    horizAdvX: 260,
    d: "M130 267q-42 0 -69 26.5t-27 68.5q0 41 27 68.5t69 27.5q41 0 68.5 -27.5t27.5 -68.5q0 -42 -27 -68.5t-69 -26.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft.cap",
    horizAdvX: 365,
    d: "M235 355q0 -246 108 -458h-143q-110 180 -110 458t110 458h143q-108 -212 -108 -458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright.cap",
    horizAdvX: 365,
    d: "M130 355q0 246 -108 458h143q110 -180 110 -458t-110 -458h-143q108 212 108 458z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft.cap",
    horizAdvX: 337,
    d: "M315 27v-131h-245v916h245v-131h-112v-654h112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright.cap",
    horizAdvX: 337,
    d: "M22 -104v131h112v654h-112v131h245v-916h-245z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft.cap",
    horizAdvX: 356,
    d: "M291 -104q-96 0 -140 47t-44 141v154q0 55 -51 55h-16v122h16q51 0 51 55v154q0 94 44 141t140 47l43 -2v-131q-17 2 -34 2q-34 0 -47 -15t-13 -49v-149q0 -78 -50 -114q50 -38 50 -114v-149q0 -34 13 -49t47 -15l34 2v-131q-18 -2 -43 -2z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright.cap",
    horizAdvX: 356,
    d: "M65 -104l-43 2v131q17 -2 34 -2q34 0 47 15t13 49v149q0 76 49 114q-49 36 -49 114v149q0 34 -13 49t-47 15l-34 -2v131q18 2 43 2q96 0 140 -47t44 -141v-154q0 -55 51 -55h16v-122h-16q-51 0 -51 -55v-154q0 -94 -44 -141t-140 -47z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at.cap",
    horizAdvX: 818,
    d: "M481 378q0 70 -62 70q-41 0 -65.5 -33t-24.5 -86q0 -36 18.5 -54.5t48.5 -18.5q40 0 62.5 36t22.5 86zM616 145h117q-52 -77 -137 -121t-182 -44q-172 0 -273 102.5t-101 266.5q0 163 109 271.5t271 108.5q159 0 258.5 -87.5t99.5 -227.5q0 -117 -63.5 -181.5 t-143.5 -64.5q-66 0 -93 45q-37 -45 -102 -45q-69 0 -110.5 43t-41.5 117q0 88 47 150.5t127 62.5q75 0 109 -48l8 34h92l-45 -223q-2 -8 -2 -13q0 -15 8.5 -25.5t23.5 -10.5q39 0 66 43t27 111q0 113 -74.5 172t-193.5 59q-123 0 -199 -80.5t-76 -208.5q0 -132 75.5 -207 t203.5 -75q54 0 107.5 21.5t87.5 54.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.slash",
    d: "M291 -15q-126 0 -192 101.5t-66 268.5t66 268.5t192 101.5t192 -101.5t66 -268.5t-66 -268.5t-192 -101.5zM291 587q-56 0 -83 -56t-27 -176q0 -78 10 -125l141 347q-17 10 -41 10zM291 123q56 0 83 56t27 176q0 74 -10 120l-140 -344q16 -8 40 -8z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "commaaccentcomb",
    horizAdvX: 249,
    d: "M94 -46h120q3 -15 3 -43q0 -36 -12 -67t-29 -50.5t-34 -33.5t-29 -20l-12 -6l-69 82q3 1 7.5 3.5t16 11t20.5 18.5t16.5 26t7.5 34z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onum",
    horizAdvX: 640,
    d: "M183 272q0 -70 38 -112.5t99 -42.5t99 42.5t38 112.5t-38 112.5t-99 42.5t-99 -42.5t-38 -112.5zM36 272q0 118 78.5 201t205.5 83t205.5 -83t78.5 -201t-78.5 -201t-205.5 -83t-205.5 83t-78.5 201z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onum",
    horizAdvX: 373,
    d: "M273 0h-144v400h-89v95l116 49h117v-544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onum",
    horizAdvX: 535,
    d: "M197 325h-144q-3 14 -3 29q0 90 59.5 146t158.5 56q91 0 153 -48t62 -141q0 -65 -37 -110.5t-110 -94.5l-54 -36h220v-126h-449v107l168 119q65 46 91 73.5t26 61.5q0 30 -18.5 49t-54.5 19t-53.5 -20.5t-17.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onum",
    horizAdvX: 560,
    d: "M213 155v124h67q44 0 66 19t22 51t-21 53t-61 21q-43 0 -64.5 -27t-21.5 -65h-142q0 96 63.5 160t164.5 64q103 0 163.5 -54t60.5 -143q0 -94 -80 -137q86 -39 86 -146q0 -90 -65.5 -151t-169.5 -61t-169 61.5t-68 163.5h142q2 -42 26 -67t69 -25q41 0 66 22t25 57 q0 80 -94 80h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onum",
    horizAdvX: 546,
    d: "M521 151v-126h-63v-149h-134v149h-309v105l293 414h150v-393h63zM178 151h146v206h-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onum",
    horizAdvX: 556,
    d: "M58 159l55 385h362v-126h-253l-17 -117q33 30 99 30q56 0 98.5 -20t66.5 -53.5t35.5 -72t11.5 -79.5q0 -101 -67 -166t-173 -65q-98 0 -161 55t-71 146h141q6 -31 30.5 -53t60.5 -22q45 0 70.5 28t25.5 77t-25.5 77.5t-70.5 28.5q-62 0 -86 -53h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onum",
    horizAdvX: 564,
    d: "M254 669h175q-129 -137 -182 -230q25 11 69 11q99 0 157 -64.5t58 -161.5q0 -101 -68 -168.5t-177 -67.5q-112 0 -179 71t-67 179q0 186 214 431zM387 224q0 47 -27.5 77t-73.5 30q-45 0 -73 -30t-28 -77q0 -48 28 -78t73 -30q47 0 74 30t27 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onum",
    horizAdvX: 507,
    d: "M483 544v-130q-81 -127 -122 -254t-62 -284h-148q43 306 176 536h-163v-88h-144v220h463z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onum",
    horizAdvX: 550,
    d: "M275 114q43 0 65.5 24t22.5 57q0 36 -23.5 58.5t-64.5 22.5t-64.5 -22.5t-23.5 -58.5q0 -33 22.5 -57t65.5 -24zM275 403q38 0 59.5 21t21.5 56q0 29 -20.5 51t-60.5 22t-60.5 -22t-20.5 -51q0 -35 21.5 -56t59.5 -21zM275 -12q-107 0 -169 54t-62 143q0 107 82 159 q-66 52 -66 141q0 84 58 138.5t157 54.5t157 -54.5t58 -138.5q0 -89 -66 -141q82 -52 82 -159q0 -89 -62 -143t-169 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onum",
    horizAdvX: 556,
    d: "M310 -125h-175q129 137 182 230q-25 -11 -69 -11q-99 0 -157 64.5t-58 161.5q0 101 68 168.5t177 67.5q112 0 179 -71t67 -179q0 -186 -214 -431zM177 320q0 -47 27.5 -77t73.5 -30q45 0 73 30t28 77q0 48 -28 78t-73 30q-47 0 -74 -30t-27 -78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.pnum",
    d: "M291 -15q-126 0 -192 101.5t-66 268.5t66 268.5t192 101.5t192 -101.5t66 -268.5t-66 -268.5t-192 -101.5zM291 587q-56 0 -83 -56t-27 -176t27 -176t83 -56t83 56t27 176t-27 176t-83 56z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.pnum",
    horizAdvX: 409,
    d: "M294 710v-710h-146v566h-108v95l136 49h118z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.pnum",
    horizAdvX: 564,
    d: "M530 0h-489v120l278 270q53 50 53 113q0 39 -27 63.5t-69 24.5q-47 0 -71.5 -27.5t-24.5 -70.5l3 -39h-144q-3 17 -3 41q0 103 66.5 166.5t173.5 63.5q110 0 176 -61t66 -158q0 -70 -26 -121t-91 -109l-161 -142h290v-134z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.pnum",
    horizAdvX: 568,
    d: "M217 303v121h66q51 0 77 22.5t26 60.5t-24.5 62.5t-71.5 24.5q-50 0 -75 -29.5t-25 -70.5h-142q0 98 67.5 164.5t174.5 66.5q109 0 173 -57.5t64 -151.5q0 -107 -96 -149q104 -40 104 -158q0 -95 -70.5 -159.5t-180.5 -64.5q-109 0 -178 63t-73 168h142q2 -45 30 -72.5 t79 -27.5q48 0 77 26t29 67q0 43 -26.5 68.5t-82.5 25.5h-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.pnum",
    horizAdvX: 589,
    d: "M556 272v-127h-68v-145h-134v145h-332v108l313 457h153v-438h68zM354 520h-1l-170 -248h171v248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.pnum",
    horizAdvX: 579,
    d: "M56 295l59 415h387v-134h-277l-20 -140q16 16 47.5 28.5t65.5 12.5q60 0 105.5 -21.5t70.5 -58t36.5 -77.5t11.5 -85q0 -109 -70.5 -179.5t-184.5 -70.5q-106 0 -172.5 58.5t-74.5 155.5h147q7 -34 32.5 -57.5t67.5 -23.5q50 0 79.5 32t29.5 85t-29.5 85t-79.5 32 q-32 0 -56.5 -14t-33.5 -28l-9 -15h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.pnum",
    horizAdvX: 564,
    d: "M287 -15q-116 0 -186.5 75t-70.5 185q0 105 60 218.5t177 246.5h176q-144 -154 -208 -263q35 19 83 19q103 0 163.5 -67.5t60.5 -167.5q0 -104 -71.5 -175t-183.5 -71zM394 231q0 52 -30 85t-77 33t-77 -33t-30 -85t30 -85t77 -33t77 33t30 85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.pnum",
    horizAdvX: 510,
    d: "M497 710v-130q-90 -157 -125.5 -278.5t-58.5 -301.5h-151q21 169 63 305t116 273h-177v-88h-144v220h477z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.pnum",
    horizAdvX: 572,
    d: "M286 -15q-114 0 -180 57t-66 151q0 52 24 99.5t70 74.5q-77 51 -77 153q0 90 62 147.5t167 57.5t168 -58.5t63 -148.5q0 -101 -79 -151q46 -28 70 -75t24 -99q0 -94 -66 -151t-180 -57zM286 296q-46 0 -73 -26t-27 -66q0 -38 26 -65t74 -27t74 27t26 65q0 40 -27 66 t-73 26zM286 427q44 0 69.5 24t25.5 63q0 34 -25 60t-70 26t-69 -25t-24 -59q0 -40 25 -64.5t68 -24.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.pnum",
    horizAdvX: 564,
    d: "M277 725q116 0 186.5 -75t70.5 -185q0 -105 -60 -218.5t-177 -246.5h-176q144 157 208 262q-35 -18 -83 -18q-103 0 -163.5 67.5t-60.5 167.5q0 104 71.5 175t183.5 71zM170 479q0 -52 30 -85t77 -33t77 33t30 85t-30 85t-77 33t-77 -33t-30 -85z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.dnom",
    horizAdvX: 406,
    d: "M147 215q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM37 215q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.dnom",
    horizAdvX: 292,
    d: "M220 433v-433h-109v325h-83v78l100 30h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.dnom",
    horizAdvX: 392,
    d: "M350 0h-308v84l167 142q34 29 34 67q0 20 -12 34t-36 14q-23 0 -36 -13t-13 -37l2 -24h-108q-1 11 -1 25q0 66 45 108.5t111 42.5q69 0 113.5 -41.5t44.5 -101.5q0 -48 -17.5 -80.5t-59.5 -64.5l-69 -53h143v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.dnom",
    horizAdvX: 389,
    d: "M144 168v90h44q25 0 38.5 12t13.5 33q0 16 -12.5 27.5t-32.5 11.5q-24 0 -37 -14t-13 -37h-106q0 63 42 107t114 44t111 -35t39 -93q0 -68 -54 -96q59 -26 59 -97q0 -57 -46 -94.5t-113 -37.5q-68 0 -108.5 38.5t-42.5 102.5h105q3 -41 46 -41q19 0 30.5 10.5t11.5 26.5 q0 42 -50 42h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.dnom",
    horizAdvX: 398,
    d: "M372 176v-91h-56v-85h-98v85h-190v89l180 259h108v-257h56zM218 303l-88 -127h88v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.dnom",
    horizAdvX: 400,
    d: "M39 136h110q4 -49 49 -49q54 0 54 57q0 26 -14 41t-40 15q-19 0 -31 -8.5t-15 -17.5l-2 -8h-101l37 266h249v-102h-165l-7 -48q21 11 52 11q75 0 110.5 -44.5t35.5 -104.5q0 -69 -45.5 -112t-119.5 -43q-67 0 -109.5 40t-47.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.dnom",
    horizAdvX: 391,
    d: "M172 432h137q-85 -90 -114 -137q7 1 22 1q69 0 107.5 -42.5t38.5 -108.5q0 -67 -44.5 -111.5t-117.5 -44.5q-76 0 -120 47t-44 118q0 121 135 278zM252 145q0 26 -14 42.5t-37 16.5t-37.5 -16.5t-14.5 -42.5t14.5 -42t37.5 -16q22 0 36.5 16t14.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.dnom",
    horizAdvX: 361,
    d: "M341 433v-96q-103 -142 -129 -337h-112q24 190 119 331h-87v-49h-106v151h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.dnom",
    horizAdvX: 388,
    d: "M194 83q24 0 36.5 12t12.5 31q0 18 -12.5 31t-36.5 13t-36.5 -13t-12.5 -31q0 -19 12.5 -31t36.5 -12zM194 268q22 0 34 11t12 30q0 16 -12 27.5t-34 11.5t-34 -11.5t-12 -27.5q0 -19 12 -30t34 -11zM194 -11q-73 0 -115 36t-42 95q0 68 50 102q-41 36 -41 90 q0 58 40.5 94t107.5 36t107.5 -36t40.5 -94q0 -54 -41 -90q50 -34 50 -102q0 -59 -42 -95t-115 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.dnom",
    horizAdvX: 391,
    d: "M219 0h-137q85 90 114 137q-7 -1 -22 -1q-69 0 -107.5 42.5t-38.5 108.5q0 67 44.5 111.5t117.5 44.5q76 0 120 -47t44 -118q0 -121 -135 -278zM139 287q0 -26 14 -42.5t37 -16.5t37.5 16.5t14.5 42.5t-14.5 42t-37.5 16q-22 0 -36.5 -16t-14.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.numerator",
    horizAdvX: 406,
    d: "M147 492q0 -71 13.5 -97.5t42.5 -26.5t42.5 26.5t13.5 97.5t-13.5 98t-42.5 27t-42.5 -27t-13.5 -98zM37 492q0 105 40.5 166t125.5 61t125.5 -61t40.5 -166t-40.5 -165.5t-125.5 -60.5t-125.5 60.5t-40.5 165.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.numerator",
    horizAdvX: 292,
    d: "M220 710v-433h-109v325h-83v78l100 30h92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.numerator",
    horizAdvX: 392,
    d: "M350 277h-308v84l167 142q34 29 34 67q0 20 -12 34t-36 14q-23 0 -36 -13t-13 -37l2 -24h-108q-1 11 -1 25q0 66 45 108.5t111 42.5q69 0 113.5 -41.5t44.5 -101.5q0 -48 -17.5 -80.5t-59.5 -64.5l-69 -53h143v-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.numerator",
    horizAdvX: 389,
    d: "M144 445v90h44q25 0 38.5 12t13.5 33q0 16 -12.5 27.5t-32.5 11.5q-24 0 -37 -14t-13 -37h-106q0 63 42 107t114 44t111 -35t39 -93q0 -68 -54 -96q59 -26 59 -97q0 -57 -46 -94.5t-113 -37.5q-68 0 -108.5 38.5t-42.5 102.5h105q3 -41 46 -41q19 0 30.5 10.5t11.5 26.5 q0 42 -50 42h-39z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.numerator",
    horizAdvX: 398,
    d: "M372 453v-91h-56v-85h-98v85h-190v89l180 259h108v-257h56zM218 580l-88 -127h88v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.numerator",
    horizAdvX: 400,
    d: "M39 414h110q4 -49 49 -49q54 0 54 57q0 26 -14 41t-40 15q-19 0 -31 -8.5t-15 -17.5l-2 -8h-101l37 266h249v-102h-165l-7 -48q21 11 52 11q75 0 110.5 -44.5t35.5 -104.5q0 -69 -45.5 -112t-119.5 -43q-67 0 -109.5 40t-47.5 107z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.numerator",
    horizAdvX: 391,
    d: "M172 710h137q-85 -90 -114 -137q7 1 22 1q69 0 107.5 -42.5t38.5 -108.5q0 -67 -44.5 -111.5t-117.5 -44.5q-76 0 -120 47t-44 118q0 121 135 278zM252 423q0 26 -14 42.5t-37 16.5t-37.5 -16.5t-14.5 -42.5t14.5 -42t37.5 -16q22 0 36.5 16t14.5 42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.numerator",
    horizAdvX: 361,
    d: "M341 710v-96q-103 -142 -129 -337h-112q24 190 119 331h-87v-49h-106v151h315z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.numerator",
    horizAdvX: 388,
    d: "M194 360q24 0 36.5 12t12.5 31t-12.5 31.5t-36.5 12.5t-36.5 -12.5t-12.5 -31.5t12.5 -31t36.5 -12zM194 545q22 0 34 11t12 30q0 16 -12 27.5t-34 11.5t-34 -11.5t-12 -27.5q0 -19 12 -30t34 -11zM194 266q-73 0 -115 36t-42 95q0 68 50 102q-41 36 -41 90q0 58 40.5 94 t107.5 36t107.5 -36t40.5 -94q0 -54 -41 -90q50 -34 50 -102q0 -59 -42 -95t-115 -36z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.numerator",
    horizAdvX: 391,
    d: "M219 277h-137q85 90 114 137q-7 -1 -22 -1q-69 0 -107.5 42.5t-38.5 108.5q0 67 44.5 111.5t117.5 44.5q76 0 120 -47t44 -118q0 -121 -135 -278zM139 564q0 -26 14 -42.5t37 -16.5t37.5 16.5t14.5 42.5t-14.5 42t-37.5 16q-22 0 -36.5 -16t-14.5 -42z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro.oldstyle",
    horizAdvX: 588,
    d: "M53 198v105h66q-1 10 -1 30v29h-65v105h82q30 103 105 157t179 54q30 0 59 -4t43 -8l14 -4v-135q-52 18 -116 18q-95 0 -132 -78h162v-105h-184q-1 -10 -1 -29q0 -21 1 -30h184v-105h-161q35 -77 131 -77q27 0 56 4.5t45 8.5l15 5v-134q-48 -17 -116 -17 q-105 0 -179.5 53.5t-104.5 156.5h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar.oldstyle",
    horizAdvX: 593,
    d: "M267 -125v123q-102 10 -157.5 73t-55.5 148h142q0 -80 71 -97v151l-28 8q-167 48 -167 196q0 73 52.5 127t142.5 64v102h72v-102q90 -12 140.5 -74t50.5 -148h-142q0 64 -49 88v-134l13 -4q92 -28 135 -75.5t43 -131.5q0 -75 -52 -128t-139 -63v-123h-72zM214 481 q0 -22 11.5 -36.5t41.5 -24.5v121q-25 -6 -39 -22t-14 -38zM386 189q0 42 -47 62v-126q47 19 47 64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent.oldstyle",
    horizAdvX: 579,
    d: "M256 -13v111q-87 13 -142 79t-55 159q0 92 55 158.5t142 78.5v116h69v-116q82 -10 130 -66t55 -120h-137q-11 41 -48 57v-217q38 16 48 58h136q-4 -40 -24 -78.5t-62 -70t-98 -38.5v-111h-69zM193 336q0 -89 63 -111v221q-63 -22 -63 -110z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling.oldstyle",
    horizAdvX: 597,
    d: "M78 246v96h45q-26 65 -26 129q0 91 62.5 149t165.5 58q100 0 163.5 -59t63.5 -155l-4 -41h-142q4 15 4 39q0 39 -22 63t-63 24q-38 0 -62 -23t-24 -61q0 -44 34 -123h145v-96h-119q1 -8 1 -17q0 -49 -23 -82q17 -4 45.5 -13.5t52 -15.5t46.5 -6t45 12t32 24l11 13l79 -85 q-2 -4 -6.5 -10t-20.5 -22t-35.5 -28t-52.5 -22t-70 -10q-49 0 -108.5 21t-97.5 21q-23 0 -45 -12t-32 -24l-10 -13l-80 85q4 6 11.5 16t34 31.5t58.5 31.5q40 22 40 69q0 20 -7 36h-89z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "florin.oldstyle",
    horizAdvX: 463,
    d: "M302 303l-62 -311q-16 -79 -64 -120.5t-125 -41.5q-22 0 -45 5t-36 11l-12 5l46 116q20 -11 43 -11q45 0 55 51l58 296h-74l23 123h75l19 91q34 162 189 162q22 0 45 -5.5t35 -10.5l13 -5l-46 -116q-20 11 -43 11q-45 0 -55 -51l-15 -76h73l-23 -123h-74z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen.oldstyle",
    horizAdvX: 526,
    d: "M4 679h154l104 -238h2l104 238h154l-157 -321h99v-97h-128v-60h128v-97h-128v-104h-146v104h-130v97h130v60h-130v97h100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero.onumtab",
    horizAdvX: 552,
    d: "M519 272q0 -124 -66 -204t-177 -80t-177 80t-66 204t66 204t177 80t177 -80t66 -204zM180 272q0 -75 25 -115t71 -40t71 40t25 115t-25 115t-71 40t-71 -40t-25 -115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one.onumtab",
    horizAdvX: 552,
    d: "M516 120v-120h-448v120h151v280h-148v95l176 49h118v-424h151z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two.onumtab",
    horizAdvX: 552,
    d: "M200 325h-144q-3 14 -3 29q0 90 59.5 146t158.5 56q91 0 153 -48t62 -141q0 -65 -37 -110.5t-110 -94.5l-54 -36h220v-126h-449v107l168 119q65 46 91 73.5t26 61.5q0 30 -18.5 49t-54.5 19t-53.5 -20.5t-17.5 -52.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three.onumtab",
    horizAdvX: 552,
    d: "M209 155v124h67q44 0 66 19t22 51t-21 53t-61 21q-43 0 -64.5 -27t-21.5 -65h-142q0 96 63.5 160t164.5 64q103 0 163.5 -54t60.5 -143q0 -94 -80 -137q86 -39 86 -146q0 -90 -65.5 -151t-169.5 -61t-169 61.5t-68 163.5h142q2 -42 26 -67t69 -25q41 0 66 22t25 57 q0 80 -94 80h-65z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four.onumtab",
    horizAdvX: 552,
    d: "M548 151v-126h-84v-149h-134v149h-309v105l293 414h150v-393h84zM184 151h146v206h-1z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five.onumtab",
    horizAdvX: 552,
    d: "M56 159l55 385h363v-126h-254l-17 -117q33 30 99 30q56 0 98.5 -20t66.5 -53.5t35.5 -72t11.5 -79.5q0 -101 -67 -166t-173 -65q-98 0 -161 55t-71 146h141q6 -31 30.5 -53t60.5 -22q45 0 70.5 28t25.5 77t-25.5 77.5t-70.5 28.5q-62 0 -86 -53h-132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six.onumtab",
    horizAdvX: 552,
    d: "M246 669h175q-129 -137 -182 -230q25 11 69 11q99 0 157 -64.5t58 -161.5q0 -101 -68 -168.5t-177 -67.5q-112 0 -179 71t-67 179q0 186 214 431zM379 224q0 47 -27.5 77t-73.5 30q-45 0 -73 -30t-28 -77q0 -48 28 -78t73 -30q47 0 74 30t27 78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven.onumtab",
    horizAdvX: 552,
    d: "M528 544v-130q-89 -116 -136.5 -243t-75.5 -295h-148q48 304 195 536h-194v-88h-144v220h503z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight.onumtab",
    horizAdvX: 498,
    d: "M249 114q43 0 65.5 24t22.5 57q0 36 -23.5 58.5t-64.5 22.5t-64.5 -22.5t-23.5 -58.5q0 -33 22.5 -57t65.5 -24zM249 403q38 0 59.5 21t21.5 56q0 29 -20.5 51t-60.5 22t-60.5 -22t-20.5 -51q0 -35 21.5 -56t59.5 -21zM249 -12q-107 0 -169 54t-62 143q0 107 82 159 q-66 52 -66 141q0 84 58 138.5t157 54.5t157 -54.5t58 -138.5q0 -89 -66 -141q82 -52 82 -159q0 -89 -62 -143t-169 -54z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine.onumtab",
    horizAdvX: 552,
    d: "M307 -125h-175q129 137 182 230q-25 -11 -69 -11q-99 0 -157 64.5t-58 161.5q0 101 68 168.5t177 67.5q112 0 179 -71t67 -179q0 -186 -214 -431zM174 320q0 -47 27.5 -77t73.5 -30q45 0 73 30t28 77q0 48 -28 78t-73 30q-47 0 -74 -30t-27 -78z"
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1EF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E84",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E82",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u1E80",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u01FA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0178",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0176",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0174",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0134",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0104",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0102",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\u0100",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xDD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "\xC0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "Y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "W",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "J",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: " ",
    u2: "A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1EF2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E84",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E82",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u1E80",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0178",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0176",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0174",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0166",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0164",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\u0162",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "\xDD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "Y",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "W",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "&",
    u2: "T",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u01FA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0104",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0102",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\u0100",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "\xC0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "*",
    u2: "A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ",",
    u2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "-",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: ".",
    u2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u2026",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u201E",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: "\u201A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "?",
    u2: ",",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "A",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "\u0134",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "B",
    u2: "J",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "D",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u2026",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201E",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u201A",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1EF3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E85",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E83",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u1E81",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0219",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0218",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FC",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u01FA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0177",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0175",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0173",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0171",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u016B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0169",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0161",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0160",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u015A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0159",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0157",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0155",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0153",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0152",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0151",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0150",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u014C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0134",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0123",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0122",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0121",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0120",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011E",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u011C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0119",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0117",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0115",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0113",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0111",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u010A",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0109",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0108",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0107",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0106",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0104",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0102",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\u0100",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xFA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xEA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xD2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC6",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC1",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xC0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "\xB5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "y",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "w",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "v",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "s",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "r",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "p",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "o",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "n",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "m",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "g",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "e",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "d",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "c",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "S",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "Q",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "O",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "J",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "G",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "C",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: "A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ".",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "F",
    u2: ",",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "G",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    g2: "periodcentered.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "\xB7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "L",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "O",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u2026",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201E",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u201A",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0219",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FF",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FD",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FC",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FB",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u01FA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0173",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0171",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u016B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0169",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0161",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u015D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0159",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0157",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0155",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0153",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0151",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u014D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0134",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0131",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u012B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0129",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0123",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0121",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u011D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0119",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0117",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0115",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0113",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0111",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010F",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010D",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u010B",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0109",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0107",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0105",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0104",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0103",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0102",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0101",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\u0100",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xFA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF8",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF4",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xF0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xED",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEC",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xEA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE8",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE7",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE6",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE4",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE2",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE1",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xE0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC6",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xC0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "\xB5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "u",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "s",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "r",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "q",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "o",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "n",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "m",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "i",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "g",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "e",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "d",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "c",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "a",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "J",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: "A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ".",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "P",
    u2: ",",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Q",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "R",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "S",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "T",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "emdash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    g2: "endash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2026",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201E",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u201A",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u1EF3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0219",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0218",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FC",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FB",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u01FA",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0177",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0173",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0171",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016F",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016D",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u016B",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0169",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0161",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0160",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015E",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015C",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u015A",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0159",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0157",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0155",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0153",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0152",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0151",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0150",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u014C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0134",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0123",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0122",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0121",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0120",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011E",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u011C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0119",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0117",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0115",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0113",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0111",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010F",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010D",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010B",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u010A",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0109",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0108",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0107",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0106",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0105",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0104",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0103",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0102",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0101",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\u0100",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFF",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFD",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFC",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFB",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xFA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xF0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEB",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xEA",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE9",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE6",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE4",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xE0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xD2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC6",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC5",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC4",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC3",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC2",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC1",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xC0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "\xB5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "y",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "x",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "v",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "u",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "s",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "r",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "q",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "p",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "o",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "n",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "m",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "g",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "e",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "d",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "c",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "a",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "S",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "Q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "O",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "J",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "C",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "A",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ".",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: ",",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "V",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "W",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "emdash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    g2: "endash.cap",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2014",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u2013",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1EF3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E85",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E83",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u1E81",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FF",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FE",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FD",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u01FB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0177",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0175",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0173",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0171",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u016B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0169",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0153",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0152",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0151",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0150",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014E",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u014C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0123",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0122",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0121",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0120",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011F",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011E",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011D",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u011C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0119",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0117",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0115",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0113",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0111",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010B",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u010A",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0109",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0108",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0107",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0106",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0105",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0103",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\u0101",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFF",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFD",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFC",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xFA",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF9",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xF0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEB",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xEA",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE9",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE7",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE6",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE5",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE4",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE3",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE2",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xE0",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD8",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD6",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD5",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD4",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD3",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xD2",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xC7",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "\xB5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "y",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "w",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "v",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "u",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "q",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "o",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "g",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "e",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "d",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "c",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "a",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "Q",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "O",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "G",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "C",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "X",
    u2: "-",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "Y",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "b",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "c",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "d",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "e",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u2026",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201E",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u201A",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u01FB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0153",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0151",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u014F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u014D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0123",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0121",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u011F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u011D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0119",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0117",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0115",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0113",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0111",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010D",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u010B",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0109",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0107",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0105",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0103",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\u0101",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xF0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xEA",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE6",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "\xE0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "}",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "q",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "o",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "g",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "e",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "d",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "a",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "]",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "?",
    k: -11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ".",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ",",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: "*",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "f",
    u2: ")",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1EF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E85",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E83",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u1E81",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u0177",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\u0175",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xFF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "\xFD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "y",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "w",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "n",
    u2: "v",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "o",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "p",
    u2: "p",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FD",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u01FB",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0153",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0151",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u014D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0123",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0121",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011F",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u011D",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0119",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0117",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0115",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0113",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0111",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010F",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010D",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u010B",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0109",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0107",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0105",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0103",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\u0101",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF8",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xF0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xEA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE7",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE6",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE5",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE2",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE1",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "\xE0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "q",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "o",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "g",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "e",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "d",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "c",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "x",
    u2: "a",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u1EF3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u1EF2",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0178",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0177",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0176",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0166",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0164",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\u0162",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xFD",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "\xDD",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "y",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "v",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "f",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "Y",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xBF",
    u2: "T",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC0",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC1",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC2",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC3",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC4",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC5",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xC7",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD0",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD2",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD3",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD4",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD5",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD6",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xD8",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xDD",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE6",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE7",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE8",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xE9",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEA",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xEB",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF0",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF2",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF3",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF4",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF5",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF6",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xF8",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\xFE",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0100",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0102",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0104",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0106",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0107",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0108",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0109",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010A",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010B",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "x",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010D",
    u2: "c",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0167",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0165",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0163",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u013E",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0131",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012F",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012D",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u012B",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\u0129",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEF",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEE",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xED",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "\xEC",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "t",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "l",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "k",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "j",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "i",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "h",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "f",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u010F",
    u2: "b",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0110",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0113",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0115",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0117",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0119",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011C",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u011E",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0120",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0122",
    u2: "G",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    g2: "periodcentered.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "\xB7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0139",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    g2: "periodcentered.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "\xB7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013B",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    g2: "periodcentered.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "\xB7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013D",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0167",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0165",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0163",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u013E",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0131",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012F",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012D",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u012B",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\u0129",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEF",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEE",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xED",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "\xEC",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "t",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "l",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "k",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "j",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "i",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "h",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "f",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u013E",
    u2: "b",
    k: -133
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    g2: "periodcentered.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "\xB7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0141",
    u2: "V",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014C",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014D",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014E",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u014F",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0150",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0151",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0153",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0154",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0156",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0158",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015A",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015C",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u015E",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0160",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0162",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0164",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "x",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "p",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0166",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0174",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0176",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0178",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\u2122",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "\xAE",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "V",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "?",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: "*",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FA",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FD",
    u2: "x",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FE",
    u2: "V",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u01FF",
    u2: "x",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u0218",
    u2: "V",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E80",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E82",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1E84",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "x",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "p",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: "&",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u1EF2",
    u2: " ",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2013",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2014",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201A",
    u2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u201E",
    u2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2026",
    u2: "V",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "nine.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "eight.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "seven.dnom",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "six.dnom",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "five.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "four.dnom",
    k: 177
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "three.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "two.dnom",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "one.dnom",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    u1: "\u2044",
    g2: "zero.dnom",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "endash.cap",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "endash.cap",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "emdash.cap",
    u2: "X",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "emdash.cap",
    u2: "V",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    g2: "emdash.cap",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    g2: "endash.cap",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2026",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u201E",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u201A",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2014",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "\u2013",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: ".",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: "-",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.onum",
    u2: ",",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    g2: "emdash.cap",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    g2: "endash.cap",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2026",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u201E",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u201A",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2014",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "\u2013",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ";",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ":",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ".",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: "-",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.pnum",
    u2: ",",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "one.numerator",
    u2: "\u2044",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.numerator",
    u2: "\u2044",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "three.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "four.numerator",
    u2: "\u2044",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "five.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "six.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "eight.numerator",
    u2: "\u2044",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine.numerator",
    u2: "\u2044",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteright,quotedblright",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quotedbl,quotesingle",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "quoteleft,quotedblleft",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Ccircumflex,Cdotaccent,Ccaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,Jcircumflex",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent",
    g2: "J,Jcircumflex",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteright,quotedblright",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quotedbl,quotesingle",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,O,Q,Eth,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Dcaron,Dcroat,Omacron,Obreve,Ohungarumlaut,Oslashacute",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "J,Jcircumflex",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "AE,AEacute",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "m,n,r,racute,rcommaaccent,rcaron",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,Tbar",
    g2: "hyphen,endash,emdash,endash.cap,emdash.cap",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Utilde,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "AE,AEacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scircumflex,Scedilla,Scaron,Scommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,Jcircumflex",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "J,Jcircumflex",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "AE,AEacute",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "m,n,r,racute,rcommaaccent,rcaron",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    g2: "hyphen,endash,emdash,endash.cap,emdash.cap",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "C,G,O,Q,Ccedilla,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Cacute,Ccircumflex,Cdotaccent,Ccaron,Gcircumflex,Gbreve,Gdotaccent,Gcommaaccent,Omacron,Obreve,Ohungarumlaut,OE,Oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "u,mu,ugrave,uacute,ucircumflex,udieresis,utilde,umacron,ubreve,uring,uhungarumlaut,uogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron",
    g2: "Z,Zacute,Zdotaccent,Zcaron",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,ccircumflex,cdotaccent,ccaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,oe,aeacute",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,o,p,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,thorn,omacron,obreve,ohungarumlaut,oslashacute",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,scircumflex,scedilla,scaron,scommaaccent",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron,tbar",
    g2: "t,tcommaaccent,tcaron,tbar",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,scircumflex,scedilla,scaron,scommaaccent",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,Jcircumflex",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 222
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "e,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,d,o,q,ccedilla,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,ccircumflex,cdotaccent,ccaron,dcaron,dcroat,omacron,obreve,ohungarumlaut,oe,oslashacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "g,gcircumflex,gbreve,gdotaccent,gcommaaccent",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    k: 222
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quotedbl,quotesingle",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "v,y,yacute,ydieresis,ycircumflex,ygrave",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,endash.cap,emdash.cap",
    g2: "T,Tcommaaccent,Tcaron,Tbar",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash,endash.cap,emdash.cap",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,Ygrave",
    k: 66
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEina03Bold);
export default __webpack_public_path__ + "static/media/Eina03Bold.832206fd9e29e2b07aa8b4cbeff9e074.svg";
export { ForwardRef as ReactComponent };